export default (name, namedImport = "default") => {
  let Module;
  if (PLATFORM_TYPE != "undefined" && PLATFORM_TYPE == "web") {
    try {
      Module = require(`private/${name}`);
    } catch (e) {
      Module = require(`common/${name}`);
    }
  } else {
    switch (name) {
      case "i18n":
        Module = require("private/i18n");
        break;
      case "GraphQL/Queries/getPhoneTypes":
        Module = require("common/GraphQL/Queries/getPhoneTypes");
        break;
      case "GraphQL/Queries/getEthnicityOptions":
        Module = require("common/GraphQL/Queries/getEthnicityOptions");
        break;
      case "GraphQL/Queries/getLanguages":
        Module = require("common/GraphQL/Queries/getLanguages");
        break;
      case "GraphQL/Queries/getMessages":
        Module = require("common/GraphQL/Queries/getMessages");
        break;
      case "GraphQL/Queries/getCenters":
        Module = require("common/GraphQL/Queries/getCenters");
        break;
      case "GraphQL/Queries/getCentersForMobile":
        Module = require("common/GraphQL/Queries/getCentersForMobile");
        break;
      case "GraphQL/Queries/getGenders":
        Module = require("common/GraphQL/Queries/getGenders");
        break;
      case "GraphQL/Queries/getCountries":
        Module = require("common/GraphQL/Queries/getCountries");
        break;
      case "GraphQL/Queries/getAllStates":
        Module = require("common/GraphQL/Queries/getAllStates");
        break;
      case "GraphQL/Queries":
        Module = require("common/GraphQL/Queries");
        break;
      case "GraphQL/Queries/getLoyaltyMilestones":
        Module = require("common/GraphQL/Queries/getLoyaltyMilestones");
        break;
      case "GraphQL/Queries/getLoyaltyAchievementBadges":
        Module = require("common/GraphQL/Queries/getLoyaltyAchievementBadges");
        break;
      case "Sagas/Centers/getAlternateDonorCentersInfo/main":
        Module = require("common/Sagas/Centers/getAlternateDonorCentersInfo/main");
        break;
      case "Sagas/Centers/getAlternateDonorCentersInfo/success":
        Module = require("common/Sagas/Centers/getAlternateDonorCentersInfo/success");
        break;
      case "Sagas/Centers/getAlternateDonorCentersInfo/failure":
        Module = require("common/Sagas/Centers/getAlternateDonorCentersInfo/failure");
        break;
      case "Sagas/PublicContent/getBlogsPage/main":
        Module = require("common/Sagas/PublicContent/getBlogsPage/main");
        break;
      case "Sagas/PublicContent/getBlogsPage/success":
        Module = require("common/Sagas/PublicContent/getBlogsPage/success");
        break;
      case "Sagas/PublicContent/getBlogsPage/failure":
        Module = require("common/Sagas/PublicContent/getBlogsPage/failure");
        break;
      case "Sagas/PublicContent/drupalMenuFetch/main":
        Module = require("common/Sagas/PublicContent/drupalMenuFetch/main");
        break;
      case "Sagas/PublicContent/drupalMenuFetch/success":
        Module = require("common/Sagas/PublicContent/drupalMenuFetch/success");
        break;
      case "Sagas/PublicContent/drupalMenuFetch/failure":
        Module = require("common/Sagas/PublicContent/drupalMenuFetch/failure");
        break;
      case "Sagas/PublicContent/getNewsPage/main":
        Module = require("common/Sagas/PublicContent/getNewsPage/main");
        break;
      case "Sagas/PublicContent/getNewsPage/success":
        Module = require("common/Sagas/PublicContent/getNewsPage/success");
        break;
      case "Sagas/PublicContent/getNewsPage/failure":
        Module = require("common/Sagas/PublicContent/getNewsPage/failure");
        break;
      case "Sagas/PublicContent/getDrupalHomepage/main":
        Module = require("common/Sagas/PublicContent/getDrupalHomepage/main");
        break;
      case "Sagas/PublicContent/getDrupalHomepage/success":
        Module = require("common/Sagas/PublicContent/getDrupalHomepage/success");
        break;
      case "Sagas/PublicContent/getDrupalHomepage/failure":
        Module = require("common/Sagas/PublicContent/getDrupalHomepage/failure");
        break;
      case "Sagas/PublicContent/getPostLoginPage/main":
        Module = require("common/Sagas/PublicContent/getPostLoginPage/main");
        break;
      case "Sagas/PublicContent/getPostLoginPage/success":
        Module = require("common/Sagas/PublicContent/getPostLoginPage/success");
        break;
      case "Sagas/PublicContent/getPostLoginPage/failure":
        Module = require("common/Sagas/PublicContent/getPostLoginPage/failure");
        break;
      case "Sagas/PublicContent/getCenterDetailsPage/main":
        Module = require("common/Sagas/PublicContent/getCenterDetailsPage/main");
        break;
      case "Sagas/PublicContent/getCenterDetailsPage/success":
        Module = require("common/Sagas/PublicContent/getCenterDetailsPage/success");
        break;
      case "Sagas/PublicContent/getCenterDetailsPage/failure":
        Module = require("common/Sagas/PublicContent/getCenterDetailsPage/failure");
        break;
      case "Sagas/PublicContent/getPatientTestimonials/main":
        Module = require("common/Sagas/PublicContent/getPatientTestimonials/main");
        break;
      case "Sagas/PublicContent/getPatientTestimonials/success":
        Module = require("common/Sagas/PublicContent/getPatientTestimonials/success");
        break;
      case "Sagas/PublicContent/getPatientTestimonials/failure":
        Module = require("common/Sagas/PublicContent/getPatientTestimonials/failure");
        break;
      case "Sagas/PublicContent/getDrupalNavigation/main":
        Module = require("private/Sagas/PublicContent/getDrupalNavigation/main");
        break;
      case "Sagas/PublicContent/getDrupalNavigation/success":
        Module = require("common/Sagas/PublicContent/getDrupalNavigation/success");
        break;
      case "Sagas/PublicContent/getDrupalNavigation/failure":
        Module = require("common/Sagas/PublicContent/getDrupalNavigation/failure");
        break;
      case "Sagas/PublicContent/getFormsPage/main":
        Module = require("common/Sagas/PublicContent/getFormsPage/main");
        break;
      case "Sagas/PublicContent/getFormsPage/success":
        Module = require("common/Sagas/PublicContent/getFormsPage/success");
        break;
      case "Sagas/PublicContent/getFormsPage/failure":
        Module = require("common/Sagas/PublicContent/getFormsPage/failure");
        break;
      case "Helpers/drupalComponentGrouper":
        Module = require("common/Helpers/drupalComponentGrouper");
        break;
      case "Sagas/PublicContent/getCustomPage/main":
        Module = require("common/Sagas/PublicContent/getCustomPage/main");
        break;
      case "Sagas/PublicContent/getCustomPage/success":
        Module = require("common/Sagas/PublicContent/getCustomPage/success");
        break;
      case "Sagas/PublicContent/getCustomPage/failure":
        Module = require("common/Sagas/PublicContent/getCustomPage/failure");
        break;
      case "Sagas/PublicContent/getPromotionalBanner/main":
        Module = require("common/Sagas/PublicContent/getPromotionalBanner/main");
        break;
      case "Sagas/PublicContent/getPromotionalBanner/success":
        Module = require("common/Sagas/PublicContent/getPromotionalBanner/success");
        break;
      case "Sagas/PublicContent/getPromotionalBanner/failure":
        Module = require("common/Sagas/PublicContent/getPromotionalBanner/failure");
        break;
      case "Sagas/PublicContent/getOnboardingScreenData/main":
        Module = require("common/Sagas/PublicContent/getOnboardingScreenData/main");
        break;
      case "Sagas/PublicContent/getOnboardingScreenData/success":
        Module = require("common/Sagas/PublicContent/getOnboardingScreenData/success");
        break;
      case "Sagas/PublicContent/getOnboardingScreenData/failure":
        Module = require("common/Sagas/PublicContent/getOnboardingScreenData/failure");
        break;
      case "Sagas/PublicContent/getMobileScreenData/main":
        Module = require("common/Sagas/PublicContent/getMobileScreenData/main");
        break;
      case "Sagas/PublicContent/getMobileScreenData/success":
        Module = require("common/Sagas/PublicContent/getMobileScreenData/success");
        break;
      case "Sagas/PublicContent/getMobileScreenData/failure":
        Module = require("common/Sagas/PublicContent/getMobileScreenData/failure");
        break;
      case "Sagas/PublicContent/getDrupalRegistrationPage/main":
        Module = require("common/Sagas/PublicContent/getDrupalRegistrationPage/main");
        break;
      case "Sagas/PublicContent/getDrupalRegistrationPage/success":
        Module = require("common/Sagas/PublicContent/getDrupalRegistrationPage/success");
        break;
      case "Sagas/PublicContent/getDrupalRegistrationPage/failure":
        Module = require("common/Sagas/PublicContent/getDrupalRegistrationPage/failure");
        break;
      case "Containers/AlternateDonationCenters":
        Module = require("private/Containers/AlternateDonationCenters");
        break;
      case "Sagas/PublicContent/getLocationsPage/main":
        Module = require("common/Sagas/PublicContent/getLocationsPage/main");
        break;
      case "Sagas/PublicContent/getLocationsPage/failure":
        Module = require("common/Sagas/PublicContent/getLocationsPage/failure");
        break;
      case "Sagas/PublicContent/getLocationsPage/success":
        Module = require("common/Sagas/PublicContent/getLocationsPage/success");
        break;
      case "Sagas/Constants/drupalConstants":
        Module = require("common/Sagas/Constants/drupalConstants");
        break;
      case "Sagas/Donors/getDonorApcStatus/main":
        Module = require("common/Sagas/Donors/getDonorApcStatus/main");
        break;
      case "Sagas/Donors/getDonorApcStatus/success":
        Module = require("common/Sagas/Donors/getDonorApcStatus/success");
        break;
      case "Sagas/Donors/getDonorApcStatus/failure":
        Module = require("common/Sagas/Donors/getDonorApcStatus/failure");
        break;
      case "Constant/CMSToolkitContentConfig":
        Module = require("private/Constant/CMSToolkitContentConfig");
        break;
      case "Constant/Utils":
        Module = require("private/Constant/Utils");
        break;
      case "Constant/renderDrupalComponent":
        Module = require("private/Constant/renderDrupalComponent");
        break;
      case "GraphQL/Queries/getRedeemPaused":
        Module = require("common/GraphQL/Queries/getRedeemPaused");
        break;
      case "GraphQL/Queries/getVendorRedeemPaused":
        Module = require("common/GraphQL/Queries/getVendorRedeemPaused");
        break;
      case "Sagas/PublicContent/getRedeemPaused/main":
        Module = require("common/Sagas/PublicContent/getRedeemPaused/main");
        break;
      case "Sagas/PublicContent/getRedeemPaused/success":
        Module = require("common/Sagas/PublicContent/getRedeemPaused/success");
        break;
      case "Sagas/PublicContent/getRedeemPaused/failure":
        Module = require("common/Sagas/PublicContent/getRedeemPaused/failure");
        break;
      case "Sagas/PublicContent/getVendorRedeemPaused/main":
        Module = require("common/Sagas/PublicContent/getVendorRedeemPaused/main");
        break;
      case "Sagas/PublicContent/getVendorRedeemPaused/success":
        Module = require("common/Sagas/PublicContent/getVendorRedeemPaused/success");
        break;
      case "Sagas/PublicContent/getVendorRedeemPaused/failure":
        Module = require("common/Sagas/PublicContent/getVendorRedeemPaused/failure");
        break;
      case "Sagas/PublicContent/getLoyaltyMilestones/main":
        Module = require("common/Sagas/PublicContent/getLoyaltyMilestones/main");
        break;
      case "Sagas/PublicContent/getLoyaltyMilestones/success":
        Module = require("common/Sagas/PublicContent/getLoyaltyMilestones/success");
        break;
      case "Sagas/PublicContent/getLoyaltyMilestones/failure":
        Module = require("common/Sagas/PublicContent/getLoyaltyMilestones/failure");
        break;
      case "Sagas/PublicContent/getLoyaltyAchievementBadges/main":
        Module = require("common/Sagas/PublicContent/getLoyaltyAchievementBadges/main");
        break;
      case "Sagas/PublicContent/getLoyaltyAchievementBadges/success":
        Module = require("common/Sagas/PublicContent/getLoyaltyAchievementBadges/success");
        break;
      case "Sagas/PublicContent/getLoyaltyAchievementBadges/failure":
        Module = require("common/Sagas/PublicContent/getLoyaltyAchievementBadges/failure");
        break;
      case "Stores/Loyalty/Actions":
        Module = require("common/Stores/Loyalty/Actions");
        break;
      case "Stores/Preview/Actions":
        Module = require("common/Stores/Preview/Actions");
        break;
      case "Sagas/Loyalty":
        Module = require("common/Sagas/Loyalty");
        break;
      case "Sagas/Global":
        Module = require("common/Sagas/Global");
        break;
      case "Sagas/Global/preview/main":
        Module = require("common/Sagas/Global/preview/main");
        break;
      case "Sagas/Global/preview/success":
        Module = require("common/Sagas/Global/preview/success");
        break;
      case "Sagas/Global/preview/failure":
        Module = require("common/Sagas/Global/preview/failure");
        break;
      case "Sagas/Loyalty/getLoyaltyDetails/main":
        Module = require("common/Sagas/Loyalty/getLoyaltyDetails/main");
        break;
      case "Sagas/Loyalty/getLoyaltyDetails/success":
        Module = require("common/Sagas/Loyalty/getLoyaltyDetails/success");
        break;
      case "Sagas/Loyalty/getLoyaltyDetails/failure":
        Module = require("common/Sagas/Loyalty/getLoyaltyDetails/failure");
        break;
      case "Sagas/Loyalty/getLoyaltyPromotions/main":
        Module = require("common/Sagas/Loyalty/getLoyaltyPromotions/main");
        break;
      case "Sagas/Loyalty/getLoyaltyPromotions/success":
        Module = require("common/Sagas/Loyalty/getLoyaltyPromotions/success");
        break;
      case "Sagas/Loyalty/getLoyaltyPromotions/failure":
        Module = require("common/Sagas/Loyalty/getLoyaltyPromotions/failure");
        break;
      case "Sagas/Chatbot":
        Module = require("common/Sagas/Chatbot");
        break;
      case "Sagas/Chatbot/getChatbotInitialstate/main":
        Module = require("common/Sagas/Chatbot/getChatbotInitialstate/main");
        break;
      case "Sagas/Chatbot/getChatbotInitialstate/success":
        Module = require("common/Sagas/Chatbot/getChatbotInitialstate/success");
        break;
      case "Sagas/Chatbot/getChatbotInitialstate/failure":
        Module = require("common/Sagas/Chatbot/getChatbotInitialstate/failure");
        break;
      case "Sagas/Chatbot/getChatbotResponse/main":
        Module = require("common/Sagas/Chatbot/getChatbotResponse/main");
        break;
      case "Sagas/Chatbot/getChatbotResponse/success":
        Module = require("common/Sagas/Chatbot/getChatbotResponse/success");
        break;
      case "Sagas/Chatbot/getChatbotResponse/failure":
        Module = require("common/Sagas/Chatbot/getChatbotResponse/failure");
        break;
      case "Stores/Chatbot/InitialState":
        Module = require("common/Stores/Chatbot/InitialState");
        break;
      case "Stores/Chatbot/Actions":
        Module = require("common/Stores/Chatbot/Actions");
        break;
      case "Stores/Chatbot/Reducers":
        Module = require("common/Stores/Chatbot/Reducers");
        break;
      case "APIs/chatbot":
        Module = require("common/APIs/chatbot");
        break;
      case "APIs/loyalty":
        Module = require("common/APIs/loyalty");
        break;
      case "APIs/auth/deloit/enrollMfa":
        Module = require("common/APIs/auth/deloit/enrollMfa");
        break;
      case "APIs/auth/deloit/verifyMfaCode":
        Module = require("common/APIs/auth/deloit/verifyMfaCode");
        break;
      case "APIs/auth/deloit/sendMfaCode":
        Module = require("common/APIs/auth/deloit/sendMfaCode");
        break;
      case "Stores/Loyalty/Reducers":
        Module = require("common/Stores/Loyalty/Reducers");
        break;
      case "Stores/Loyalty/InitialState":
        Module = require("common/Stores/Loyalty/InitialState");
        break;
      case "Sagas/Loyalty/getLoyaltyActivity/main":
        Module = require("common/Sagas/Loyalty/getLoyaltyActivity/main");
        break;
      case "Sagas/Loyalty/getLoyaltyActivity/success":
        Module = require("common/Sagas/Loyalty/getLoyaltyActivity/success");
        break;
      case "Sagas/Loyalty/getLoyaltyActivity/failure":
        Module = require("common/Sagas/Loyalty/getLoyaltyActivity/failure");
        break;
      case "Sagas/Loyalty/getLoyaltyContants/main":
        Module = require("common/Sagas/Loyalty/getLoyaltyContants/main");
        break;
      case "Sagas/Loyalty/getLoyaltyContants/success":
        Module = require("common/Sagas/Loyalty/getLoyaltyContants/success");
        break;
      case "Sagas/Loyalty/getLoyaltyContants/failure":
        Module = require("common/Sagas/Loyalty/getLoyaltyContants/failure");
        break;
      case "Sagas/Loyalty/redeemRewards/main":
        Module = require("common/Sagas/Loyalty/redeemRewards/main");
        break;
      case "Sagas/Loyalty/redeemRewards/success":
        Module = require("common/Sagas/Loyalty/redeemRewards/success");
        break;
      case "Sagas/Loyalty/redeemRewards/failure":
        Module = require("common/Sagas/Loyalty/redeemRewards/failure");
        break;
      case "Sagas/Loyalty/redeemRewardsStatusCheck/main":
        Module = require("common/Sagas/Loyalty/redeemRewardsStatusCheck/main");
        break;
      case "Sagas/Loyalty/redeemRewardsStatusCheck/success":
        Module = require("common/Sagas/Loyalty/redeemRewardsStatusCheck/success");
        break;
      case "Sagas/Loyalty/redeemRewardsStatusCheck/failure":
        Module = require("common/Sagas/Loyalty/redeemRewardsStatusCheck/failure");
        break;
      case "Sagas/Loyalty/getLoyaltyGameData/main":
        Module = require("common/Sagas/Loyalty/getLoyaltyGameData/main");
        break;
      case "Sagas/Loyalty/getLoyaltyGameData/success":
        Module = require("common/Sagas/Loyalty/getLoyaltyGameData/success");
        break;
      case "Sagas/Loyalty/getLoyaltyGameData/failure":
        Module = require("common/Sagas/Loyalty/getLoyaltyGameData/failure");
        break;
      case "Sagas/Loyalty/updateLoyaltyGameData/main":
        Module = require("common/Sagas/Loyalty/updateLoyaltyGameData/main");
        break;
      case "Sagas/Loyalty/updateLoyaltyGameData/success":
        Module = require("common/Sagas/Loyalty/updateLoyaltyGameData/success");
        break;
      case "Sagas/Loyalty/updateLoyaltyGameData/failure":
        Module = require("common/Sagas/Loyalty/updateLoyaltyGameData/failure");
        break;
      case "Sagas/Loyalty/activateLoyaltyPromotions/main":
        Module = require("common/Sagas/Loyalty/activateLoyaltyPromotions/main");
        break;
      case "Sagas/Loyalty/activateLoyaltyPromotions/success":
        Module = require("common/Sagas/Loyalty/activateLoyaltyPromotions/success");
        break;
      case "Sagas/Loyalty/activateLoyaltyPromotions/failure":
        Module = require("common/Sagas/Loyalty/activateLoyaltyPromotions/failure");
        break;
      case "Stores/PublicContent/Actions":
        Module = require("common/Stores/PublicContent/Actions");
        break;
      case "Helpers/WebArticles":
        Module = require("common/Helpers/WebArticles");
        break;
      case "Helpers/sort":
        Module = require("common/Helpers/sort");
        break;
      case "Sagas/PublicContent/getMessages/main":
        Module = require("private/Sagas/PublicContent/getMessages/main");
        break;
      case "Sagas/PublicContent/getMessages/success":
        Module = require("common/Sagas/PublicContent/getMessages/success");
        break;
      case "Sagas/PublicContent/getMessages/failure":
        Module = require("common/Sagas/PublicContent/getMessages/failure");
        break;
      case "Sagas/PublicContent/getCenters/main":
        Module = require("common/Sagas/PublicContent/getCenters/main");
        break;
      case "Sagas/PublicContent/getCenters/success":
        Module = require("common/Sagas/PublicContent/getCenters/success");
        break;
      case "Sagas/PublicContent/getCenters/failure":
        Module = require("common/Sagas/PublicContent/getCenters/failure");
        break;
      case "Sagas/PublicContent/getCentersForMobile/main":
        Module = require("common/Sagas/PublicContent/getCentersForMobile/main");
        break;
      case "Sagas/PublicContent/getCentersForMobile/success":
        Module = require("common/Sagas/PublicContent/getCentersForMobile/success");
        break;
      case "Sagas/PublicContent/getCentersForMobile/failure":
        Module = require("common/Sagas/PublicContent/getCentersForMobile/failure");
        break;
      case "Sagas/PublicContent/getGenders/main":
        Module = require("common/Sagas/PublicContent/getGenders/main");
        break;
      case "Sagas/PublicContent/getGenders/success":
        Module = require("common/Sagas/PublicContent/getGenders/success");
        break;
      case "Sagas/PublicContent/getGenders/failure":
        Module = require("common/Sagas/PublicContent/getGenders/failure");
        break;
      case "Sagas/PublicContent/getCountries/main":
        Module = require("common/Sagas/PublicContent/getCountries/main");
        break;
      case "Sagas/PublicContent/getCountries/success":
        Module = require("common/Sagas/PublicContent/getCountries/success");
        break;
      case "Sagas/PublicContent/getCountries/failure":
        Module = require("common/Sagas/PublicContent/getCountries/failure");
        break;
      case "Sagas/PublicContent/getAllStates/main":
        Module = require("common/Sagas/PublicContent/getAllStates/main");
        break;
      case "Sagas/PublicContent/getAllStates/success":
        Module = require("common/Sagas/PublicContent/getAllStates/success");
        break;
      case "Sagas/PublicContent/getAllStates/failure":
        Module = require("common/Sagas/PublicContent/getAllStates/failure");
        break;
      case "Sagas/PublicContent/getLanguages/main":
        Module = require("common/Sagas/PublicContent/getLanguages/main");
        break;
      case "Sagas/PublicContent/getLanguages/success":
        Module = require("common/Sagas/PublicContent/getLanguages/success");
        break;
      case "Sagas/PublicContent/getLanguages/failure":
        Module = require("common/Sagas/PublicContent/getLanguages/failure");
        break;
      case "Sagas/PublicContent/getPhoneTypes/main":
        Module = require("common/Sagas/PublicContent/getPhoneTypes/main");
        break;
      case "Sagas/PublicContent/getPhoneTypes/success":
        Module = require("common/Sagas/PublicContent/getPhoneTypes/success");
        break;
      case "Sagas/PublicContent/getPhoneTypes/failure":
        Module = require("common/Sagas/PublicContent/getPhoneTypes/failure");
        break;
      case "Sagas/PublicContent/getEthnicityOptions/main":
        Module = require("common/Sagas/PublicContent/getEthnicityOptions/main");
        break;
      case "Sagas/PublicContent/getEthnicityOptions/success":
        Module = require("common/Sagas/PublicContent/getEthnicityOptions/success");
        break;
      case "Sagas/PublicContent/getEthnicityOptions/failure":
        Module = require("common/Sagas/PublicContent/getEthnicityOptions/failure");
        break;
      case "Sagas/PublicContent/saveContactForm/main":
        Module = require("common/Sagas/PublicContent/saveContactForm/main");
        break;
      case "Sagas/PublicContent/saveContactForm/success":
        Module = require("common/Sagas/PublicContent/saveContactForm/success");
        break;
      case "Sagas/PublicContent/saveContactForm/failure":
        Module = require("common/Sagas/PublicContent/saveContactForm/failure");
        break;
      case "Sagas/PublicContent":
        Module = require("common/Sagas/PublicContent");
        break;
      case "Stores/Appointments/Actions":
        Module = require("common/Stores/Appointments/Actions");
        break;
      case "APIs/appointments":
        Module = require("common/APIs/appointments");
        break;
      case "Stores/Users/Select":
        Module = require("common/Stores/Users/Select");
        break;
      case "Sagas/Appointments/scheduleAppointment/main":
        Module = require("common/Sagas/Appointments/scheduleAppointment/main");
        break;
      case "Sagas/Appointments/scheduleAppointment/success":
        Module = require("common/Sagas/Appointments/scheduleAppointment/success");
        break;
      case "Sagas/Appointments/scheduleAppointment/failure":
        Module = require("common/Sagas/Appointments/scheduleAppointment/failure");
        break;
      case "Sagas/Appointments/scheduleQuickAppointment/main":
        Module = require("common/Sagas/Appointments/scheduleQuickAppointment/main");
        break;
      case "Sagas/Appointments/scheduleQuickAppointment/success":
        Module = require("common/Sagas/Appointments/scheduleQuickAppointment/success");
        break;
      case "Sagas/Appointments/scheduleQuickAppointment/failure":
        Module = require("common/Sagas/Appointments/scheduleQuickAppointment/failure");
        break;
      case "Sagas/Appointments/getAllAppointments/main":
        Module = require("common/Sagas/Appointments/getAllAppointments/main");
        break;
      case "Sagas/Appointments/getAllAppointments/success":
        Module = require("common/Sagas/Appointments/getAllAppointments/success");
        break;
      case "Sagas/Appointments/getAllAppointments/failure":
        Module = require("common/Sagas/Appointments/getAllAppointments/failure");
        break;
      case "Sagas/Appointments/newDonorBonusEligibility/main":
        Module = require("common/Sagas/Appointments/newDonorBonusEligibility/main");
        break;
      case "Sagas/Appointments/newDonorBonusEligibility/success":
        Module = require("common/Sagas/Appointments/newDonorBonusEligibility/success");
        break;
      case "Sagas/Appointments/newDonorBonusEligibility/failure":
        Module = require("common/Sagas/Appointments/newDonorBonusEligibility/failure");
        break;
      case "Sagas/Appointments/getAppointment/main":
        Module = require("common/Sagas/Appointments/getAppointment/main");
        break;
      case "Sagas/Appointments/getAppointment/success":
        Module = require("common/Sagas/Appointments/getAppointment/success");
        break;
      case "Stores/Users/Actions":
        Module = require("common/Stores/Users/Actions");
        break;
      case "Sagas/Appointments/getUpcomingAppointments/main":
        Module = require("common/Sagas/Appointments/getUpcomingAppointments/main");
        break;
      case "Sagas/Appointments/getUpcomingAppointments/success":
        Module = require("common/Sagas/Appointments/getUpcomingAppointments/success");
        break;
      case "Sagas/Appointments/getAvailableSlots/main":
        Module = require("common/Sagas/Appointments/getAvailableSlots/main");
        break;
      case "Sagas/Appointments/getAvailableSlots/success":
        Module = require("common/Sagas/Appointments/getAvailableSlots/success");
        break;
      case "Sagas/Appointments/getAvailableSlots/failure":
        Module = require("common/Sagas/Appointments/getAvailableSlots/failure");
        break;
      case "Sagas/Appointments/getBookedSlots/main":
        Module = require("common/Sagas/Appointments/getBookedSlots/main");
        break;
      case "Sagas/Appointments/getBookedSlots/success":
        Module = require("common/Sagas/Appointments/getBookedSlots/success");
        break;
      case "Sagas/Appointments/getBookedSlots/failure":
        Module = require("common/Sagas/Appointments/getBookedSlots/failure");
        break;
      case "Sagas/Appointments/createNewAppointment/main":
        Module = require("common/Sagas/Appointments/createNewAppointment/main");
        break;
      case "Sagas/Appointments/createNewAppointment/success":
        Module = require("common/Sagas/Appointments/createNewAppointment/success");
        break;
      case "Sagas/Appointments/validateAppointment/main":
        Module = require("common/Sagas/Appointments/validateAppointment/main");
        break;
      case "Sagas/Appointments/validateAppointment/success":
        Module = require("common/Sagas/Appointments/validateAppointment/success");
        break;
      case "Sagas/Appointments/validateAppointment/failure":
        Module = require("common/Sagas/Appointments/validateAppointment/failure");
        break;
      case "Sagas/Appointments/rescheduleAppointment/main":
        Module = require("common/Sagas/Appointments/rescheduleAppointment/main");
        break;
      case "Sagas/Appointments/cancelAppointment/main":
        Module = require("common/Sagas/Appointments/cancelAppointment/main");
        break;
      case "Sagas/Appointments/cancelAppointment/success":
        Module = require("common/Sagas/Appointments/cancelAppointment/success");
        break;
      case "Sagas/Appointments":
        Module = require("common/Sagas/Appointments");
        break;
      case "Sagas/Appointments/updateGiftCardPreference/main":
        Module = require("common/Sagas/Appointments/updateGiftCardPreference/main");
        break;
      case "Sagas/Appointments/updateGiftCardPreference/success":
        Module = require("common/Sagas/Appointments/updateGiftCardPreference/success");
        break;
      case "Sagas/Appointments/updateGiftCardPreference/failure":
        Module = require("common/Sagas/Appointments/updateGiftCardPreference/failure");
        break;
      case "Stores/Centers/Actions":
        Module = require("common/Stores/Centers/Actions");
        break;
      case "APIs/centers":
        Module = require("common/APIs/centers");
        break;
      case "Sagas/Centers/getAllCenters/main":
        Module = require("common/Sagas/Centers/getAllCenters/main");
        break;
      case "Sagas/Centers/getAllCenters/success":
        Module = require("common/Sagas/Centers/getAllCenters/success");
        break;
      case "Sagas/Centers/getAllCenters/failure":
        Module = require("common/Sagas/Centers/getAllCenters/failure");
        break;
      case "Sagas/Centers/createApplicationUser/main":
        Module = require("common/Sagas/Centers/createApplicationUser/main");
        break;
      case "Sagas/Centers/createApplicationUser/success":
        Module = require("common/Sagas/Centers/createApplicationUser/success");
        break;
      case "Sagas/Centers/createApplicationUser/failure":
        Module = require("common/Sagas/Centers/createApplicationUser/failure");
        break;
      case "Sagas/Centers/searchApplicationUser/main":
        Module = require("common/Sagas/Centers/searchApplicationUser/main");
        break;
      case "Sagas/Centers/searchApplicationUser/success":
        Module = require("common/Sagas/Centers/searchApplicationUser/success");
        break;
      case "Sagas/Centers/searchApplicationUser/failure":
        Module = require("common/Sagas/Centers/searchApplicationUser/failure");
        break;
      case "Sagas/Centers/getApplicationUserDetails/main":
        Module = require("common/Sagas/Centers/getApplicationUserDetails/main");
        break;
      case "Sagas/Centers/getApplicationUserDetails/success":
        Module = require("common/Sagas/Centers/getApplicationUserDetails/success");
        break;
      case "Sagas/Centers/getApplicationUserDetails/failure":
        Module = require("common/Sagas/Centers/getApplicationUserDetails/failure");
        break;
      case "Sagas/Centers/editApplicationUser/main":
        Module = require("common/Sagas/Centers/editApplicationUser/main");
        break;
      case "Sagas/Centers/editApplicationUser/success":
        Module = require("common/Sagas/Centers/editApplicationUser/success");
        break;
      case "Sagas/Centers/editApplicationUser/failure":
        Module = require("common/Sagas/Centers/editApplicationUser/failure");
        break;
      case "Sagas/Centers/removeUserCenterAccess/main":
        Module = require("common/Sagas/Centers/removeUserCenterAccess/main");
        break;
      case "Sagas/Centers/removeUserCenterAccess/success":
        Module = require("common/Sagas/Centers/removeUserCenterAccess/success");
        break;
      case "Sagas/Centers/removeUserCenterAccess/failure":
        Module = require("common/Sagas/Centers/removeUserCenterAccess/failure");
        break;
      case "Sagas/Centers/updateUserDefaultCenter/main":
        Module = require("common/Sagas/Centers/updateUserDefaultCenter/main");
        break;
      case "Sagas/Centers/updateUserDefaultCenter/success":
        Module = require("common/Sagas/Centers/updateUserDefaultCenter/success");
        break;
      case "Sagas/Centers/updateUserDefaultCenter/failure":
        Module = require("common/Sagas/Centers/updateUserDefaultCenter/failure");
        break;
      case "Sagas/Centers/removeUserPortalAccess/main":
        Module = require("common/Sagas/Centers/removeUserPortalAccess/main");
        break;
      case "Sagas/Centers/removeUserPortalAccess/success":
        Module = require("common/Sagas/Centers/removeUserPortalAccess/success");
        break;
      case "Sagas/Centers/removeUserPortalAccess/failure":
        Module = require("common/Sagas/Centers/removeUserPortalAccess/failure");
        break;
      case "Sagas/Centers/addUserCenterAccess/main":
        Module = require("common/Sagas/Centers/addUserCenterAccess/main");
        break;
      case "Sagas/Centers/addUserCenterAccess/success":
        Module = require("common/Sagas/Centers/addUserCenterAccess/success");
        break;
      case "Sagas/Centers/addUserCenterAccess/failure":
        Module = require("common/Sagas/Centers/addUserCenterAccess/failure");
        break;
      case "Sagas/Centers/getAppointmentCenter/main":
        Module = require("common/Sagas/Centers/getAppointmentCenter/main");
        break;
      case "Sagas/Centers/getAppointmentCenter/success":
        Module = require("common/Sagas/Centers/getAppointmentCenter/success");
        break;
      case "Sagas/Centers/getAppointmentCenter/failure":
        Module = require("common/Sagas/Centers/getAppointmentCenter/failure");
        break;
      case "Sagas/Centers/getDonorCenterInfo/main":
        Module = require("common/Sagas/Centers/getDonorCenterInfo/main");
        break;
      case "Sagas/Centers/getDonorCenterInfo/success":
        Module = require("common/Sagas/Centers/getDonorCenterInfo/success");
        break;
      case "Sagas/Centers/getDonorCenterInfo/failure":
        Module = require("common/Sagas/Centers/getDonorCenterInfo/failure");
        break;
      case "Sagas/Centers/getFavoriteCenterInfo/main":
        Module = require("common/Sagas/Centers/getFavoriteCenterInfo/main");
        break;
      case "Sagas/Centers/getFavoriteCenterInfo/success":
        Module = require("common/Sagas/Centers/getFavoriteCenterInfo/success");
        break;
      case "Sagas/Centers/getFavoriteCenterInfo/failure":
        Module = require("common/Sagas/Centers/getFavoriteCenterInfo/failure");
        break;
      case "Sagas/Centers/updateFavoriteCenter/main":
        Module = require("common/Sagas/Centers/updateFavoriteCenter/main");
        break;
      case "Sagas/Centers/updateFavoriteCenter/success":
        Module = require("common/Sagas/Centers/updateFavoriteCenter/success");
        break;
      case "Sagas/Centers/updateFavoriteCenter/failure":
        Module = require("common/Sagas/Centers/updateFavoriteCenter/failure");
        break;
      case "Sagas/Centers/getCenterInfo/main":
        Module = require("common/Sagas/Centers/getCenterInfo/main");
        break;
      case "Sagas/Centers/getCenterInfo/success":
        Module = require("common/Sagas/Centers/getCenterInfo/success");
        break;
      case "Sagas/Centers/getCenterInfo/failure":
        Module = require("common/Sagas/Centers/getCenterInfo/failure");
        break;
      case "Sagas/Centers/getDonorCentersAll/main":
        Module = require("common/Sagas/Centers/getDonorCentersAll/main");
        break;
      case "Sagas/Centers/getDonorCentersAll/success":
        Module = require("common/Sagas/Centers/getDonorCentersAll/success");
        break;
      case "Sagas/Centers/getStateCenters/main":
        Module = require("common/Sagas/Centers/getStateCenters/main");
        break;
      case "Sagas/Centers/getStateCenters/success":
        Module = require("common/Sagas/Centers/getStateCenters/success");
        break;
      case "Sagas/Centers/getStateCenters/failure":
        Module = require("common/Sagas/Centers/getStateCenters/failure");
        break;
      case "Sagas/Centers/getZipcodeSearchCenters/main":
        Module = require("common/Sagas/Centers/getZipcodeSearchCenters/main");
        break;
      case "Sagas/Centers/getZipcodeSearchCenters/success":
        Module = require("common/Sagas/Centers/getZipcodeSearchCenters/success");
        break;
      case "Sagas/Centers/getZipcodeSearchCenters/failure":
        Module = require("common/Sagas/Centers/getZipcodeSearchCenters/failure");
        break;
      case "Sagas/Centers/getAppointmentSlot/main":
        Module = require("common/Sagas/Centers/getAppointmentSlot/main");
        break;
      case "Sagas/Centers/getAppointmentSlot/success":
        Module = require("common/Sagas/Centers/getAppointmentSlot/success");
        break;
      case "Sagas/Centers/getAppointmentSlot/failure":
        Module = require("common/Sagas/Centers/getAppointmentSlot/failure");
        break;
      case "Sagas/Centers/addAppointmentSlot/main":
        Module = require("common/Sagas/Centers/addAppointmentSlot/main");
        break;
      case "Sagas/Centers/addAppointmentSlot/success":
        Module = require("common/Sagas/Centers/addAppointmentSlot/success");
        break;
      case "Sagas/Centers/addAppointmentSlot/failure":
        Module = require("common/Sagas/Centers/addAppointmentSlot/failure");
        break;
      case "Sagas/Centers/getSlotsForAppointmentType/main":
        Module = require("common/Sagas/Centers/getSlotsForAppointmentType/main");
        break;
      case "Sagas/Centers/getSlotsForAppointmentType/success":
        Module = require("common/Sagas/Centers/getSlotsForAppointmentType/success");
        break;
      case "Sagas/Centers/getSlotsForAppointmentType/failure":
        Module = require("common/Sagas/Centers/getSlotsForAppointmentType/failure");
        break;
      case "Sagas/Centers/getSlotsForDonor/main":
        Module = require("common/Sagas/Centers/getSlotsForDonor/main");
        break;
      case "Sagas/Centers/getSlotsForDonor/success":
        Module = require("common/Sagas/Centers/getSlotsForDonor/success");
        break;
      case "Sagas/Centers/getSlotsForDonor/failure":
        Module = require("common/Sagas/Centers/getSlotsForDonor/failure");
        break;
      case "Sagas/Centers/downloadReport/main":
        Module = require("common/Sagas/Centers/downloadReport/main");
        break;
      case "Sagas/Centers/downloadReport/success":
        Module = require("common/Sagas/Centers/downloadReport/success");
        break;
      case "Sagas/Centers/downloadReport/failure":
        Module = require("common/Sagas/Centers/downloadReport/failure");
        break;
      case "Sagas/Centers/getAppointmentReport/main":
        Module = require("common/Sagas/Centers/getAppointmentReport/main");
        break;
      case "Sagas/Centers/getAppointmentReport/success":
        Module = require("common/Sagas/Centers/getAppointmentReport/success");
        break;
      case "Sagas/Centers/getAppointmentReport/failure":
        Module = require("common/Sagas/Centers/getAppointmentReport/failure");
        break;
      case "Sagas/Centers/getCenterCalendar/main":
        Module = require("common/Sagas/Centers/getCenterCalendar/main");
        break;
      case "Sagas/Centers/getCenterCalendar/success":
        Module = require("common/Sagas/Centers/getCenterCalendar/success");
        break;
      case "Sagas/Centers/getCenterCalendar/failure":
        Module = require("common/Sagas/Centers/getCenterCalendar/failure");
        break;
      case "Sagas/Centers/getCenterSlotConfig/main":
        Module = require("common/Sagas/Centers/getCenterSlotConfig/main");
        break;
      case "Sagas/Centers/getCenterSlotConfig/success":
        Module = require("common/Sagas/Centers/getCenterSlotConfig/success");
        break;
      case "Sagas/Centers/getCenterSlotConfig/failure":
        Module = require("common/Sagas/Centers/getCenterSlotConfig/failure");
        break;
      case "Sagas/Centers/saveCenterSlotConfig/main":
        Module = require("common/Sagas/Centers/saveCenterSlotConfig/main");
        break;
      case "Sagas/Centers/saveCenterSlotConfig/success":
        Module = require("common/Sagas/Centers/saveCenterSlotConfig/success");
        break;
      case "Sagas/Centers/saveCenterSlotConfig/failure":
        Module = require("common/Sagas/Centers/saveCenterSlotConfig/failure");
        break;
      case "Sagas/Centers/registerGetCenters/main":
        Module = require("common/Sagas/Centers/registerGetCenters/main");
        break;
      case "Stores/Donors/Actions":
        Module = require("common/Stores/Donors/Actions");
        break;
      case "Sagas/Centers/registerGetCenters/success":
        Module = require("common/Sagas/Centers/registerGetCenters/success");
        break;
      case "Sagas/Centers/registerGetCenters/failure":
        Module = require("common/Sagas/Centers/registerGetCenters/failure");
        break;
      case "Sagas/Centers":
        Module = require("common/Sagas/Centers");
        break;
      case "APIs/donors":
        Module = require("common/APIs/donors");
        break;
      case "Sagas/Donors/getAllDonors/main":
        Module = require("common/Sagas/Donors/getAllDonors/main");
        break;
      case "Sagas/Donors/getAllDonors/success":
        Module = require("common/Sagas/Donors/getAllDonors/success");
        break;
      case "Sagas/Donors/getAllDonors/failure":
        Module = require("common/Sagas/Donors/getAllDonors/failure");
        break;
      case "Sagas/Donors/getDonors/main":
        Module = require("common/Sagas/Donors/getDonors/main");
        break;
      case "Sagas/Donors/getDonors/success":
        Module = require("common/Sagas/Donors/getDonors/success");
        break;
      case "Sagas/Donors/getDonors/failure":
        Module = require("common/Sagas/Donors/getDonors/failure");
        break;
      case "Sagas/Donors/getDonorBySfid/main":
        Module = require("common/Sagas/Donors/getDonorBySfid/main");
        break;
      case "Sagas/Donors/getDonorBySfid/success":
        Module = require("common/Sagas/Donors/getDonorBySfid/success");
        break;
      case "Sagas/Donors/getDonorBySfid/failure":
        Module = require("common/Sagas/Donors/getDonorBySfid/failure");
        break;
      case "Sagas/Donors/searchForDonor/main":
        Module = require("common/Sagas/Donors/searchForDonor/main");
        break;
      case "Sagas/Donors/searchForDonor/success":
        Module = require("common/Sagas/Donors/searchForDonor/success");
        break;
      case "Sagas/Donors/searchForDonor/failure":
        Module = require("common/Sagas/Donors/searchForDonor/failure");
        break;
      case "Sagas/Donors/searchActiveDonors/main":
        Module = require("common/Sagas/Donors/searchActiveDonors/main");
        break;
      case "Sagas/Donors/searchActiveDonors/success":
        Module = require("common/Sagas/Donors/searchActiveDonors/success");
        break;
      case "Sagas/Donors/searchActiveDonors/failure":
        Module = require("common/Sagas/Donors/searchActiveDonors/failure");
        break;
      case "Sagas/Donors/registerDonor/main":
        Module = require("common/Sagas/Donors/registerDonor/main");
        break;
      case "Sagas/Donors/registerGetDonorProfile/main":
        Module = require("common/Sagas/Donors/registerGetDonorProfile/main");
        break;
      case "Sagas/Donors/registerGetDonorProfile/success":
        Module = require("common/Sagas/Donors/registerGetDonorProfile/success");
        break;
      case "Sagas/Donors/registerGetDonorProfile/failure":
        Module = require("common/Sagas/Donors/registerGetDonorProfile/failure");
        break;
      case "Sagas/Donors/updateDonor/main":
        Module = require("common/Sagas/Donors/updateDonor/main");
        break;
      case "Sagas/Donors/updateDonor/success":
        Module = require("private/Sagas/Donors/updateDonor/success");
        break;
      case "Sagas/Donors/updateDonor/failure":
        Module = require("common/Sagas/Donors/updateDonor/failure");
        break;
      case "Sagas/Donors/inquiryDonor/main":
        Module = require("common/Sagas/Donors/inquiryDonor/main");
        break;
      case "Sagas/Donors/inquiryDonor/success":
        Module = require("common/Sagas/Donors/inquiryDonor/success");
        break;
      case "Sagas/Donors/inquiryDonor/failure":
        Module = require("common/Sagas/Donors/inquiryDonor/failure");
        break;
      case "Sagas/Donors/getDonorsPreferences/main":
        Module = require("common/Sagas/Donors/getDonorsPreferences/main");
        break;
      case "Sagas/Donors/getDonorsPreferences/success":
        Module = require("common/Sagas/Donors/getDonorsPreferences/success");
        break;
      case "Sagas/Donors/getDonorsPreferences/failure":
        Module = require("common/Sagas/Donors/getDonorsPreferences/failure");
        break;
      case "Sagas/Donors/updateDonorsPreferences/main":
        Module = require("common/Sagas/Donors/updateDonorsPreferences/main");
        break;
      case "Sagas/Donors/updateDonorsPreferences/success":
        Module = require("common/Sagas/Donors/updateDonorsPreferences/success");
        break;
      case "Sagas/Donors/updateDonorsPreferences/failure":
        Module = require("common/Sagas/Donors/updateDonorsPreferences/failure");
        break;
      case "Sagas/Donors/getDonorLifetimeImpact/main":
        Module = require("common/Sagas/Donors/getDonorLifetimeImpact/main");
        break;
      case "Sagas/Donors/getDonorLifetimeImpact/success":
        Module = require("common/Sagas/Donors/getDonorLifetimeImpact/success");
        break;
      case "Sagas/Donors/getDonorLifetimeImpact/failure":
        Module = require("common/Sagas/Donors/getDonorLifetimeImpact/failure");
        break;
      case "Sagas/Donors/getDonorReferEarnedAmount/main":
        Module = require("common/Sagas/Donors/getDonorReferEarnedAmount/main");
        break;
      case "Sagas/Donors/getDonorReferEarnedAmount/success":
        Module = require("common/Sagas/Donors/getDonorReferEarnedAmount/success");
        break;
      case "Sagas/Donors/getDonorReferEarnedAmount/failure":
        Module = require("common/Sagas/Donors/getDonorReferEarnedAmount/failure");
        break;
      case "Sagas/Donors":
        Module = require("common/Sagas/Donors");
        break;
      case "Stores/Payments/Actions":
        Module = require("common/Stores/Payments/Actions");
        break;
      case "Stores/Wirecard/Actions":
        Module = require("common/Stores/Wirecard/Actions");
        break;
      case "APIs/users":
        Module = require("common/APIs/users");
        break;
      case "Sagas/Users/enrollMfa/main":
        Module = require("common/Sagas/Users/enrollMfa/main");
        break;
      case "Sagas/Users/enrollMfa/success":
        Module = require("common/Sagas/Users/enrollMfa/success");
        break;
      case "Sagas/Users/enrollMfa/failure":
        Module = require("common/Sagas/Users/enrollMfa/failure");
        break;
      case "Sagas/Users/resendEnrollMfaCode/main":
        Module = require("common/Sagas/Users/resendEnrollMfaCode/main");
        break;
      case "Sagas/Users/resendEnrollMfaCode/success":
        Module = require("common/Sagas/Users/resendEnrollMfaCode/success");
        break;
      case "Sagas/Users/resendEnrollMfaCode/failure":
        Module = require("common/Sagas/Users/resendEnrollMfaCode/failure");
        break;
      case "Sagas/Users/sendMfaCode/main":
        Module = require("common/Sagas/Users/sendMfaCode/main");
        break;
      case "Sagas/Users/sendMfaCode/success":
        Module = require("common/Sagas/Users/sendMfaCode/success");
        break;
      case "Sagas/Users/sendMfaCode/failure":
        Module = require("common/Sagas/Users/sendMfaCode/failure");
        break;
      case "Sagas/Users/verifyMfaCode/main":
        Module = require("common/Sagas/Users/verifyMfaCode/main");
        break;
      case "Sagas/Users/verifyMfaCode/success":
        Module = require("common/Sagas/Users/verifyMfaCode/success");
        break;
      case "Sagas/Users/verifyMfaCode/failure":
        Module = require("common/Sagas/Users/verifyMfaCode/failure");
        break;
      case "Sagas/Users/sendMfaCode/main":
        Module = require("common/Sagas/Users/sendMfaCode/main");
        break;
      case "Sagas/Users/sendMfaCode/success":
        Module = require("common/Sagas/Users/sendMfaCode/success");
        break;
      case "Sagas/Users/sendMfaCode/failure":
        Module = require("common/Sagas/Users/sendMfaCode/failure");
        break;
      case "Sagas/Users/login/failure":
        Module = require("common/Sagas/Users/login/failure");
        break;
      case "Sagas/Users/loginAuth/main":
        Module = require("common/Sagas/Users/loginAuth/main");
        break;
      case "Sagas/Users/loginAuth/failure":
        Module = require("common/Sagas/Users/loginAuth/failure");
        break;
      case "Sagas/Users/loginTokenExchange/main":
        Module = require("common/Sagas/Users/loginTokenExchange/main");
        break;
      case "Sagas/Users/loginHeroku/main":
        Module = require("common/Sagas/Users/loginHeroku/main");
        break;
      case "Stores/Startup/Actions":
        Module = require("common/Stores/Startup/Actions");
        break;
      case "Helpers/getDonorAgeGroup":
        Module = require("common/Helpers/getDonorAgeGroup");
        break;
      case "Sagas/Users/loginWithToken/main":
        Module = require("common/Sagas/Users/loginWithToken/main");
        break;
      case "Sagas/Users/loginWithProxyPdn/main":
        Module = require("common/Sagas/Users/loginWithProxyPdn/main");
        break;
      case "Sagas/Users/loginWithProxyPdn/success":
        Module = require("common/Sagas/Users/loginWithProxyPdn/success");
        break;
      case "Sagas/Users/loginWithProxyPdn/failure":
        Module = require("common/Sagas/Users/loginWithProxyPdn/failure");
        break;
      case "Sagas/Users/logout/main":
        Module = require("common/Sagas/Users/logout/main");
        break;
      case "Sagas/Users/register/main":
        Module = require("common/Sagas/Users/register/main");
        break;
      case "Sagas/Users/getSession/main":
        Module = require("common/Sagas/Users/getSession/main");
        break;
      case "Sagas/Users/getSession/success":
        Module = require("common/Sagas/Users/getSession/success");
        break;
      case "Sagas/Users/getSession/failure":
        Module = require("common/Sagas/Users/getSession/failure");
        break;
      case "Sagas/Users/getSessionUser/main":
        Module = require("common/Sagas/Users/getSessionUser/main");
        break;
      case "Sagas/Users/getSessionUser/success":
        Module = require("common/Sagas/Users/getSessionUser/success");
        break;
      case "Sagas/Users/getSessionUser/failure":
        Module = require("common/Sagas/Users/getSessionUser/failure");
        break;
      case "Sagas/Users/getLoggedInUser/main":
        Module = require("common/Sagas/Users/getLoggedInUser/main");
        break;
      case "Sagas/Users/getLoggedInUser/success":
        Module = require("common/Sagas/Users/getLoggedInUser/success");
        break;
      case "Sagas/Users/getLoggedInUser/failure":
        Module = require("common/Sagas/Users/getLoggedInUser/failure");
        break;
      case "Sagas/Users/verifyEmail/main":
        Module = require("common/Sagas/Users/verifyEmail/main");
        break;
      case "Sagas/Users/verifyEmail/success":
        Module = require("common/Sagas/Users/verifyEmail/success");
        break;
      case "Sagas/Users/verifyEmail/failure":
        Module = require("common/Sagas/Users/verifyEmail/failure");
        break;
      case "Sagas/Users/changeDefaultCenter/main":
        Module = require("common/Sagas/Users/changeDefaultCenter/main");
        break;
      case "Sagas/Users/changeDefaultCenter/success":
        Module = require("common/Sagas/Users/changeDefaultCenter/success");
        break;
      case "Sagas/Users/changeDefaultCenter/failure":
        Module = require("common/Sagas/Users/changeDefaultCenter/failure");
        break;
      case "Sagas/Users/updateAccountSetting/main":
        Module = require("common/Sagas/Users/updateAccountSetting/main");
        break;
      case "Sagas/Users/updateAccountSetting/failure":
        Module = require("common/Sagas/Users/updateAccountSetting/failure");
        break;
      case "Sagas/Users/mergeAccountSetting/main":
        Module = require("common/Sagas/Users/mergeAccountSetting/main");
        break;
      case "Stores/Donors/Select":
        Module = require("common/Stores/Donors/Select");
        break;
      case "Sagas/Users/mergeAccountSetting/success":
        Module = require("common/Sagas/Users/mergeAccountSetting/success");
        break;
      case "Sagas/Users/mergeAccountSetting/failure":
        Module = require("common/Sagas/Users/mergeAccountSetting/failure");
        break;
      case "Sagas/Users/resendVerification/main":
        Module = require("common/Sagas/Users/resendVerification/main");
        break;
      case "Sagas/Users/resendVerification/success":
        Module = require("common/Sagas/Users/resendVerification/success");
        break;
      case "Sagas/Users/resendVerification/failure":
        Module = require("common/Sagas/Users/resendVerification/failure");
        break;
      case "Sagas/Users/resetPassword/main":
        Module = require("common/Sagas/Users/resetPassword/main");
        break;
      case "Sagas/Users/resetPassword/success":
        Module = require("common/Sagas/Users/resetPassword/success");
        break;
      case "Sagas/Users/resetPassword/failure":
        Module = require("common/Sagas/Users/resetPassword/failure");
        break;
      case "Sagas/Users/resetPassword2/main":
        Module = require("common/Sagas/Users/resetPassword2/main");
        break;
      case "Sagas/Users/resetPassword2/success":
        Module = require("common/Sagas/Users/resetPassword2/success");
        break;
      case "Sagas/Users/resetPassword2/failure":
        Module = require("common/Sagas/Users/resetPassword2/failure");
        break;
      case "Sagas/Users/resetPassword3/main":
        Module = require("common/Sagas/Users/resetPassword3/main");
        break;
      case "Sagas/Users/resetPassword3/success":
        Module = require("common/Sagas/Users/resetPassword3/success");
        break;
      case "Sagas/Users/resetPassword3/failure":
        Module = require("common/Sagas/Users/resetPassword3/failure");
        break;
      case "Sagas/Users/setupNewPassword/main":
        Module = require("common/Sagas/Users/setupNewPassword/main");
        break;
      case "Sagas/Users/setupNewPassword/success":
        Module = require("common/Sagas/Users/setupNewPassword/success");
        break;
      case "Sagas/Users/setupNewPassword/failure":
        Module = require("common/Sagas/Users/setupNewPassword/failure");
        break;
      case "Sagas/Users/sessionRefresh/main":
        Module = require("common/Sagas/Users/sessionRefresh/main");
        break;
      case "Sagas/Users/sessionRefresh/success":
        Module = require("common/Sagas/Users/sessionRefresh/success");
        break;
      case "Sagas/Users/verifyOktaAccount/main":
        Module = require("common/Sagas/Users/verifyOktaAccount/main");
        break;
      case "Sagas/Users/verifyOktaAccount/success":
        Module = require("common/Sagas/Users/verifyOktaAccount/success");
        break;
      case "Sagas/Users/verifyOktaAccount/failure":
        Module = require("common/Sagas/Users/verifyOktaAccount/failure");
        break;
      case "Sagas/Users/changePassword/main":
        Module = require("common/Sagas/Users/changePassword/main");
        break;
      case "Sagas/Users/changePassword/success":
        Module = require("common/Sagas/Users/changePassword/success");
        break;
      case "Sagas/Users/changePassword/failure":
        Module = require("common/Sagas/Users/changePassword/failure");
        break;
      case "Sagas/Users/emailLogin/main":
        Module = require("common/Sagas/Users/emailLogin/main");
        break;
      case "Sagas/Users/emailLogin/success":
        Module = require("common/Sagas/Users/emailLogin/success");
        break;
      case "Sagas/Users/emailLogin/failure":
        Module = require("common/Sagas/Users/emailLogin/failure");
        break;
      case "Sagas/Users/socialLogin/main":
        Module = require("common/Sagas/Users/socialLogin/main");
        break;
      case "Sagas/Users/socialLogin/success":
        Module = require("common/Sagas/Users/socialLogin/success");
        break;
      case "Sagas/Users/socialLogin/failure":
        Module = require("common/Sagas/Users/socialLogin/failure");
        break;
      case "Sagas/Users":
        Module = require("common/Sagas/Users");
        break;
      case "APIs/wirecard":
        Module = require("common/APIs/wirecard");
        break;
      case "Sagas/Wirecard/getWirecardInfo/main":
        Module = require("common/Sagas/Wirecard/getWirecardInfo/main");
        break;
      case "Sagas/Wirecard/getWirecardInfo/success":
        Module = require("common/Sagas/Wirecard/getWirecardInfo/success");
        break;
      case "Sagas/Wirecard":
        Module = require("common/Sagas/Wirecard");
        break;
      case "Stores/AuthCustom/Actions":
        Module = require("common/Stores/AuthCustom/Actions");
        break;
      case "Sagas/AuthCustom/login/main":
        Module = require("common/Sagas/AuthCustom/login/main");
        break;
      case "Sagas/AuthCustom/login/success":
        Module = require("common/Sagas/AuthCustom/login/success");
        break;
      case "Sagas/AuthCustom/login/failure":
        Module = require("common/Sagas/AuthCustom/login/failure");
        break;
      case "Sagas/AuthCustom/loginAuth/main":
        Module = require("common/Sagas/AuthCustom/loginAuth/main");
        break;
      case "Sagas/AuthCustom/loginAuth/success":
        Module = require("common/Sagas/AuthCustom/loginAuth/success");
        break;
      case "Sagas/AuthCustom/loginAuth/failure":
        Module = require("common/Sagas/AuthCustom/loginAuth/failure");
        break;
      case "Sagas/AuthCustom/loginTokenExchange/main":
        Module = require("common/Sagas/AuthCustom/loginTokenExchange/main");
        break;
      case "Sagas/AuthCustom/loginTokenExchange/success":
        Module = require("common/Sagas/AuthCustom/loginTokenExchange/success");
        break;
      case "Sagas/AuthCustom/loginTokenExchange/failure":
        Module = require("common/Sagas/AuthCustom/loginTokenExchange/failure");
        break;
      case "Sagas/AuthCustom/loginHeroku/main":
        Module = require("common/Sagas/AuthCustom/loginHeroku/main");
        break;
      case "Sagas/AuthCustom/loginHeroku/success":
        Module = require("common/Sagas/AuthCustom/loginHeroku/success");
        break;
      case "Sagas/AuthCustom/loginHeroku/failure":
        Module = require("common/Sagas/AuthCustom/loginHeroku/failure");
        break;
      case "Stores/AuthCustom/Select":
        Module = require("common/Stores/AuthCustom/Select");
        break;
      case "Sagas/AuthCustom/logout/main":
        Module = require("common/Sagas/AuthCustom/logout/main");
        break;
      case "Sagas/AuthCustom/logout/success":
        Module = require("common/Sagas/AuthCustom/logout/success");
        break;
      case "Sagas/AuthCustom/logout/failure":
        Module = require("common/Sagas/AuthCustom/logout/failure");
        break;
      case "Sagas/AuthCustom/register/main":
        Module = require("common/Sagas/AuthCustom/register/main");
        break;
      case "Sagas/AuthCustom/register/success":
        Module = require("common/Sagas/AuthCustom/register/success");
        break;
      case "Sagas/AuthCustom/register/failure":
        Module = require("common/Sagas/AuthCustom/register/failure");
        break;
      case "Sagas/AuthCustom/getSession/main":
        Module = require("common/Sagas/AuthCustom/getSession/main");
        break;
      case "Sagas/AuthCustom/getSession/success":
        Module = require("common/Sagas/AuthCustom/getSession/success");
        break;
      case "Sagas/AuthCustom/getSession/failure":
        Module = require("common/Sagas/AuthCustom/getSession/failure");
        break;
      case "Sagas/AuthCustom/getSessionUser/main":
        Module = require("common/Sagas/AuthCustom/getSessionUser/main");
        break;
      case "Sagas/AuthCustom/getSessionUser/success":
        Module = require("common/Sagas/AuthCustom/getSessionUser/success");
        break;
      case "Sagas/AuthCustom/getSessionUser/failure":
        Module = require("common/Sagas/AuthCustom/getSessionUser/failure");
        break;
      case "Sagas/AuthCustom/changePassword/main":
        Module = require("common/Sagas/AuthCustom/changePassword/main");
        break;
      case "Sagas/AuthCustom/changePassword/success":
        Module = require("common/Sagas/AuthCustom/changePassword/success");
        break;
      case "Sagas/AuthCustom/changePassword/failure":
        Module = require("common/Sagas/AuthCustom/changePassword/failure");
        break;
      case "Sagas/AuthCustom/changeRecoveryQuestion/main":
        Module = require("common/Sagas/AuthCustom/changeRecoveryQuestion/main");
        break;
      case "Sagas/AuthCustom/changeRecoveryQuestion/success":
        Module = require("common/Sagas/AuthCustom/changeRecoveryQuestion/success");
        break;
      case "Sagas/AuthCustom/changeRecoveryQuestion/failure":
        Module = require("common/Sagas/AuthCustom/changeRecoveryQuestion/failure");
        break;
      case "Sagas/AuthCustom/forgotPassword/main":
        Module = require("common/Sagas/AuthCustom/forgotPassword/main");
        break;
      case "Sagas/AuthCustom/forgotPassword/success":
        Module = require("common/Sagas/AuthCustom/forgotPassword/success");
        break;
      case "Sagas/AuthCustom/forgotPassword/failure":
        Module = require("common/Sagas/AuthCustom/forgotPassword/failure");
        break;
      case "Sagas/AuthCustom/sessionRefresh/main":
        Module = require("common/Sagas/AuthCustom/sessionRefresh/main");
        break;
      case "Sagas/AuthCustom/sessionRefresh/success":
        Module = require("common/Sagas/AuthCustom/sessionRefresh/success");
        break;
      case "Sagas/AuthCustom/sessionRefresh/failure":
        Module = require("common/Sagas/AuthCustom/sessionRefresh/failure");
        break;
      case "Sagas/AuthCustom":
        Module = require("common/Sagas/AuthCustom");
        break;
      case "APIs/payments":
        Module = require("common/APIs/payments");
        break;
      case "Sagas/Payments/getPaymentsCouponProgress/main":
        Module = require("common/Sagas/Payments/getPaymentsCouponProgress/main");
        break;
      case "Sagas/Payments/getPaymentsCouponProgress/success":
        Module = require("common/Sagas/Payments/getPaymentsCouponProgress/success");
        break;
      case "Sagas/Payments/applyPaymentPromoCode/main":
        Module = require("common/Sagas/Payments/applyPaymentPromoCode/main");
        break;
      case "Sagas/Payments/applyPaymentPromoCode/success":
        Module = require("common/Sagas/Payments/applyPaymentPromoCode/success");
        break;
      case "Sagas/Payments/getPaymentHistory/main":
        Module = require("common/Sagas/Payments/getPaymentHistory/main");
        break;
      case "Sagas/Payments/getPaymentHistory/success":
        Module = require("common/Sagas/Payments/getPaymentHistory/success");
        break;
      case "Sagas/Payments":
        Module = require("common/Sagas/Payments");
        break;
      case "Sagas/Startup/initializeApp/initializeAppSuccess":
        Module = require("common/Sagas/Startup/initializeApp/initializeAppSuccess");
        break;
      case "Sagas/Startup/initializeApp/initializeAppFailure":
        Module = require("common/Sagas/Startup/initializeApp/initializeAppFailure");
        break;
      case "Sagas/Startup":
        Module = require("common/Sagas/Startup");
        break;
      case "Sagas/CustomSdkSagas":
        Module = require("common/Sagas/CustomSdkSagas");
        break;
      case "Stores/PublicContent/InitialState":
        Module = require("common/Stores/PublicContent/InitialState");
        break;
      case "Stores/PublicContent/Reducers":
        Module = require("common/Stores/PublicContent/Reducers");
        break;
      case "Stores/Appointments/InitialState":
        Module = require("common/Stores/Appointments/InitialState");
        break;
      case "Stores/Appointments/Reducers":
        Module = require("common/Stores/Appointments/Reducers");
        break;
      case "Stores/AuthCustom/InitialState":
        Module = require("common/Stores/AuthCustom/InitialState");
        break;
      case "Stores/AuthCustom/Reducers":
        Module = require("common/Stores/AuthCustom/Reducers");
        break;
      case "Stores/Centers/InitialState":
        Module = require("common/Stores/Centers/InitialState");
        break;
      case "Stores/Centers/Reducers":
        Module = require("common/Stores/Centers/Reducers");
        break;
      case "Stores/Users/InitialState":
        Module = require("common/Stores/Users/InitialState");
        break;
      case "Stores/Users/Reducers":
        Module = require("common/Stores/Users/Reducers");
        break;
      case "Stores/Donors/InitialState":
        Module = require("common/Stores/Donors/InitialState");
        break;
      case "Stores/Donors/Reducers":
        Module = require("common/Stores/Donors/Reducers");
        break;
      case "Stores/Wirecard/InitialState":
        Module = require("common/Stores/Wirecard/InitialState");
        break;
      case "Stores/Wirecard/Reducers":
        Module = require("common/Stores/Wirecard/Reducers");
        break;
      case "Stores/Payments/InitialState":
        Module = require("common/Stores/Payments/InitialState");
        break;
      case "Stores/Payments/Reducers":
        Module = require("common/Stores/Payments/Reducers");
        break;
      case "Stores/PublicContent/Select":
        Module = require("common/Stores/PublicContent/Select");
        break;
      case "Helpers/isValidEmail":
        Module = require("common/Helpers/isValidEmail");
        break;
      case "Helpers/validation":
        Module = require("common/Helpers/validation");
        break;
      case "Helpers/isEmpty":
        Module = require("common/Helpers/isEmpty");
        break;
      case "Helpers/debitHistory":
        Module = require("common/Helpers/debitHistory");
        break;
      case "Helpers/YoutubeId":
        Module = require("common/Helpers/YoutubeId");
        break;
      case "Containers/OptOutOfLoyalty":
        Module = require("private/Containers/OptOutOfLoyalty");
        break;
      case "Components/LoyaltyPromotionList":
        Module = require("private/Components/LoyaltyPromotionList");
        break;
      case "Components/LoyaltyPromotionCard":
        Module = require("private/Components/LoyaltyPromotionCard");
        break;
      case "Components/PromotionsDetails":
        Module = require("private/Components/PromotionsDetails");
        break;
      case "Components/PromotionAccordion":
        Module = require("private/Components/PromotionAccordion");
        break;
      case "Components/OnboardingExperience":
        Module = require("private/Components/OnboardingExperience");
        break;
      case "Components/PhysicalDateCard":
        Module = require("private/Components/PhysicalDateCard");
        break;
      case "Components/GraphicTileComponent/GraphicTileTemplateThree":
        Module = require("private/Components/GraphicTileComponent/GraphicTileTemplateThree");
        break;
      case "Containers/OptOutOfLoyalty/styles":
        Module = require("private/Containers/OptOutOfLoyalty/styles");
        break;
      case "Components/LoyaltyAdvertisementCard/styles":
        Module = require("private/Components/LoyaltyAdvertisementCard/styles");
        break;
      case "Components/LoyaltyAdvertisementCard":
        Module = require("private/Components/LoyaltyAdvertisementCard");
        break;
      case "Components/Loader":
        Module = require("private/Components/Loader");
        break;
      case "Components/BottomSheet":
        Module = require("private/Components/BottomSheet");
        break;
      case "Components/Forms/SignUpFormComponent":
        Module = require("private/Components/Forms/SignUpFormComponent");
        break;
      case "Components/Forms/ForgotPasswordForm":
        Module = require("private/Components/Forms/ForgotPasswordForm");
        break;
      case "Components/Forms/FormConfirmation":
        Module = require("private/Components/Forms/FormConfirmation");
        break;
      case "Components/Forms/CreateProfileFormComponent":
        Module = require("private/Components/Forms/CreateProfileFormComponent");
        break;
      case "Components/SettingsProfile":
        Module = require("private/Components/SettingsProfile");
        break;
      case "Components/SettingsProfile/MyInformation":
        Module = require("private/Components/SettingsProfile/MyInformation");
        break;
      case "Components/SettingsProfile/UpdateEmail":
        Module = require("private/Components/SettingsProfile/UpdateEmail");
        break;
      case "Components/SettingsProfile/UpdateEmail/styles":
        Module = require("private/Components/SettingsProfile/UpdateEmail/styles");
        break;
      case "Components/SettingsProfile/UpdatePassword":
        Module = require("private/Components/SettingsProfile/UpdatePassword");
        break;
      case "Components/SettingsProfile/SaveAndDiscardModal":
        Module = require("private/Components/SettingsProfile/SaveAndDiscardModal");
        break;
      case "Components/SettingsProfile/Info":
        Module = require("private/Components/SettingsProfile/Info");
        break;
      case "Components/SettingsPreferences":
        Module = require("private/Components/SettingsPreferences");
        break;
      case "Components/CenterWithImageCard":
        Module = require("private/Components/CenterWithImageCard");
        break;
      case "Components/CustomCarousel":
        Module = require("private/Components/CustomCarousel");
        break;
      case "Components/PromotionStatus":
        Module = require("private/Components/PromotionStatus");
        break;
      case "Components/PromotionCard":
        Module = require("private/Components/PromotionCard");
        break;
      case "Components/Forms/PromotionForm":
        Module = require("private/Components/Forms/PromotionForm");
        break;
      case "Components/LifeTimeImpactStatistics":
        Module = require("private/Components/LifeTimeImpactStatistics");
        break;
      case "Components/PromotionStatistics":
        Module = require("private/Components/PromotionStatistics");
        break;
      case "Components/LoyaltyGameProgressBar":
        Module = require("private/Components/LoyaltyGameProgressBar");
        break;
      case "Components/LoyaltyGameCard":
        Module = require("private/Components/LoyaltyGameCard");
        break;
      case "Containers/LoyaltyGameStepSuccess":
        Module = require("private/Containers/LoyaltyGameStepSuccess");
        break;
      case "Components/LoyaltyGameMissionComplete":
        Module = require("private/Components/LoyaltyGameMissionComplete");
        break;
      case "Components/LoyaltyGameWhatToExpectModal":
        Module = require("private/Components/LoyaltyGameWhatToExpectModal");
        break;
      case "Containers/Discover":
        Module = require("private/Containers/Discover");
        break;
      case "Containers/Refer":
        Module = require("private/Containers/Refer");
        break;
      case "Containers/FAQ":
        Module = require("private/Containers/FAQ");
        break;
      case "Containers/MyLoyalty":
        Module = require("private/Containers/MyLoyalty");
        break;
      case "Containers/MyLoyalty/styles":
        Module = require("private/Containers/MyLoyalty/styles");
        break;
      case "Components/LoyaltyModal":
        Module = require("private/Components/LoyaltyModal");
        break;
      case "Containers/LoyaltyDashboardTabs/RewardsHistory/styles":
        Module = require("private/Containers/LoyaltyDashboardTabs/RewardsHistory/styles");
        break;
      case "Containers/LoyaltyDashboardTabs/RewardsHistory":
        Module = require("private/Containers/LoyaltyDashboardTabs/RewardsHistory");
        break;
      case "Containers/LoyaltyDashboardTabs/WaystoEarnCard/styles":
        Module = require("private/Containers/LoyaltyDashboardTabs/WaystoEarnCard/styles");
        break;
      case "Containers/LoyaltyDashboardTabs/WaystoEarnCard":
        Module = require("private/Containers/LoyaltyDashboardTabs/WaystoEarnCard");
        break;

      case "Containers/LoyaltyDashboardTabs/MyRewards/PatientTestimonials":
        Module = require("private/Containers/LoyaltyDashboardTabs/MyRewards/PatientTestimonials");
        break;
      case "Containers/LoyaltyDashboardTabs/MyRewards/PatientTestimonials/styles":
        Module = require("private/Containers/LoyaltyDashboardTabs/MyRewards/PatientTestimonials/styles");
        break;
      case "Components/LoyaltyModal/styles":
        Module = require("private/Components/LoyaltyModal/styles");
        break;
      case "Containers/LoyaltyDashboardTabs/MyRewards/styles":
        Module = require("private/Containers/LoyaltyDashboardTabs/MyRewards/styles");
        break;
      case "Containers/LoyaltyDashboard":
        Module = require("private/Containers/LoyaltyDashboard");
        break;
      case "Containers/RedeemRewards":
        Module = require("private/Containers/RedeemRewards");
        break;
      case "Containers/RedeemRewards/styles":
        Module = require("private/Containers/RedeemRewards/styles");
        break;
      case "Components/LoyaltyDashboardCard":
        Module = require("private/Components/LoyaltyDashboardCard");
        break;
      case "Components/LoyaltyDashboardCard/styles":
        Module = require("private/Components/LoyaltyDashboardCard/styles");
        break;
      case "Containers/LoyaltyDashboardTabs":
        Module = require("private/Containers/LoyaltyDashboardTabs");
        break;
      case "Containers/LoyaltyDashboardTabs/styles":
        Module = require("private/Containers/LoyaltyDashboardTabs/styles");
        break;
      case "Components/MyLoyaltyEnrolment":
        Module = require("private/Components/MyLoyaltyEnrolment");
        break;
      case "Components/MyLoyaltyEnrolment/styles":
        Module = require("private/Components/MyLoyaltyEnrolment/styles");
        break;
      case "Components/BiolifeRewards/RewardsHistory":
        Module = require("private/Components/BiolifeRewards/RewardsHistory");
        break;
      case "Services/NavigationService":
        Module = require("private/Services/NavigationService");
        break;
      case "Stores/DeepLink/Actions":
        Module = require("private/Stores/DeepLink/Actions");
        break;
      case "Sagas/LinkingSaga":
        Module = require("private/Sagas/LinkingSaga");
        break;
      case "Config":
        Module = require("private/Config");
        break;
      case "APIs":
        Module = require("private/APIs");
        break;
      case "APIs/public":
        Module = require("private/APIs/public");
        break;
      case "Sagas/Appointments/getAppointment/failure":
        Module = require("private/Sagas/Appointments/getAppointment/failure");
        break;
      case "Sagas/Appointments/getUpcomingAppointments/failure":
        Module = require("private/Sagas/Appointments/getUpcomingAppointments/failure");
        break;
      case "Sagas/Appointments/createNewAppointment/failure":
        Module = require("private/Sagas/Appointments/createNewAppointment/failure");
        break;
      case "NavigationService":
        Module = require("private/NavigationService");
        break;
      case "Sagas/Appointments/rescheduleAppointment/success":
        Module = require("private/Sagas/Appointments/rescheduleAppointment/success");
        break;
      case "Sagas/Appointments/rescheduleAppointment/failure":
        Module = require("private/Sagas/Appointments/rescheduleAppointment/failure");
        break;
      case "Sagas/Appointments/cancelAppointment/failure":
        Module = require("private/Sagas/Appointments/cancelAppointment/failure");
        break;
      case "Sagas/Centers/getDonorCentersAll/failure":
        Module = require("private/Sagas/Centers/getDonorCentersAll/failure");
        break;
      case "Sagas/Donors/registerDonor/success":
        Module = require("private/Sagas/Donors/registerDonor/success");
        break;
      case "Helpers/Alert":
        Module = require("private/Helpers/Alert");
        break;
      case "Sagas/Donors/registerDonor/failure":
        Module = require("private/Sagas/Donors/registerDonor/failure");
        break;
      case "APIs/auth":
        Module = require("private/APIs/auth");
        break;
      case "Sagas/Users/login/main":
        Module = require("private/Sagas/Users/login/main");
        break;
      case "Sagas/Users/login/success":
        Module = require("private/Sagas/Users/login/success");
        break;
      case "Sagas/Users/loginAuth/success":
        Module = require("private/Sagas/Users/loginAuth/success");
        break;
      case "Sagas/Users/loginTokenExchange/success":
        Module = require("private/Sagas/Users/loginTokenExchange/success");
        break;
      case "Sagas/Users/loginTokenExchange/failure":
        Module = require("private/Sagas/Users/loginTokenExchange/failure");
        break;
      case "Sagas/Users/loginHeroku/success":
        Module = require("private/Sagas/Users/loginHeroku/success");
        break;
      case "Sagas/Users/loginHeroku/failure":
        Module = require("private/Sagas/Users/loginHeroku/failure");
        break;
      case "Sagas/Users/loginWithToken/success":
        Module = require("private/Sagas/Users/loginWithToken/success");
        break;
      case "Sagas/Users/loginWithToken/failure":
        Module = require("private/Sagas/Users/loginWithToken/failure");
        break;
      case "Sagas/Users/logout/success":
        Module = require("private/Sagas/Users/logout/success");
        break;
      case "Sagas/Users/logout/failure":
        Module = require("private/Sagas/Users/logout/failure");
        break;
      case "Sagas/Users/register/success":
        Module = require("private/Sagas/Users/register/success");
        break;
      case "Sagas/Users/register/failure":
        Module = require("private/Sagas/Users/register/failure");
        break;
      case "Sagas/Users/updateAccountSetting/success":
        Module = require("private/Sagas/Users/updateAccountSetting/success");
        break;
      case "Sagas/Users/sessionRefresh/failure":
        Module = require("private/Sagas/Users/sessionRefresh/failure");
        break;
      case "Sagas/Wirecard/getWirecardInfo/failure":
        Module = require("private/Sagas/Wirecard/getWirecardInfo/failure");
        break;
      case "Sagas/Payments/getPaymentsCouponProgress/failure":
        Module = require("private/Sagas/Payments/getPaymentsCouponProgress/failure");
        break;
      case "Sagas/Payments/applyPaymentPromoCode/failure":
        Module = require("private/Sagas/Payments/applyPaymentPromoCode/failure");
        break;
      case "Sagas/Payments/getPaymentHistory/failure":
        Module = require("private/Sagas/Payments/getPaymentHistory/failure");
        break;
      case "Stores/App/Actions":
        Module = require("private/Stores/App/Actions");
        break;
      case "Sagas/Startup/initializeApp/initializeApp":
        Module = require("private/Sagas/Startup/initializeApp/initializeApp");
        break;
      case "Sagas/custom":
        Module = require("private/Sagas/custom");
        break;
      case "Stores/CreateStore":
        Module = require("private/Stores/CreateStore");
        break;
      case "Stores/Account/InitialState":
        Module = require("private/Stores/Account/InitialState");
        break;
      case "Stores/Account/Actions":
        Module = require("private/Stores/Account/Actions");
        break;
      case "Stores/Account/Reducers":
        Module = require("private/Stores/Account/Reducers");
        break;
      case "Stores/App/InitialState":
        Module = require("private/Stores/App/InitialState");
        break;
      case "Stores/App/Reducers":
        Module = require("private/Stores/App/Reducers");
        break;
      case "Stores/Auth/InitialState":
        Module = require("private/Stores/Auth/InitialState");
        break;
      case "Stores/Auth/Actions":
        Module = require("private/Stores/Auth/Actions");
        break;
      case "Stores/Auth/Reducers":
        Module = require("private/Stores/Auth/Reducers");
        break;
      case "Stores/DeepLink/InitialState":
        Module = require("private/Stores/DeepLink/InitialState");
        break;
      case "Stores/DeepLink/Reducers":
        Module = require("private/Stores/DeepLink/Reducers");
        break;
      case "Stores/CustomSDKReducers":
        Module = require("private/Stores/CustomSDKReducers");
        break;
      case "Stores":
        Module = require("private/Stores");
        break;
      case "Helpers/getActiveRouteName":
        Module = require("private/Helpers/getActiveRouteName");
        break;
      case "Services/RemotePushController":
        Module = require("private/Services/RemotePushController");
        break;
      case "Images/icon-consecutive-promotion-initial":
        Module = require("private/Images/icon-consecutive-promotion-initial");
        break;
      case "Images/icon-consecutive-promotion-active":
        Module = require("private/Images/icon-consecutive-promotion-active");
        break;
      case "Images/icon-consecutive-promotion-inactive":
        Module = require("private/Images/icon-consecutive-promotion-inactive");
        break;
      case "Images/icon-time-promotion-initial":
        Module = require("private/Images/icon-time-challenge-promotion-initial");
        break;
      case "Images/icon-time-promotion-active":
        Module = require("private/Images/icon-time-challenge-promotion-active");
        break;
      case "Images/icon-time-promotion-inactive":
        Module = require("private/Images/icon-time-challenge-promotion-inactive");
        break;
      case "Images/icon-promotion-completed":
        Module = require("private/Images/icon-promotion-completed");
        break;
      case "Images/icon-green-checkmark":
        Module = require("private/Images/icon-green-checkmark");
        break;
      case "Images/icon-grey-checkmark":
        Module = require("private/Images/icon-grey-checkmark");
        break;
      case "Images/location-heart-icon":
        Module = require("private/Images/location-heart-icon");
        break;
      case "Images/location-heart-fav-icon":
        Module = require("private/Images/location-heart-fav-icon");
        break;
      case "Images/search-icon":
        Module = require("private/Images/search-icon");
        break;
      case "Images/favorite-icon":
        Module = require("private/Images/favorite-icon");
        break;
      case "Images/address-location-icon":
        Module = require("private/Images/address-location-icon");
        break;
      case "Images/information-icon":
        Module = require("private/Images/information-icon");
        break;
      case "Images/sign-up-icon-gradient-ui-success":
        Module = require("private/Images/sign-up-icon-gradient-ui-success");
        break;
      case "Images/UI-circle-info":
        Module = require("private/Images/UI-circle-info");
        break;
      case "Images/icon-menu-gift-card.png":
        Module = require("private/Images/icon-menu-gift-card.png");
        break;
      case "Images/icon-notification.png":
        Module = require("private/Images/icon-notification.png");
        break;
      case "Images/icon-gift-card.png":
        Module = require("private/Images/icon-gift-card.png");
        break;
      case "Images/icon-giftcard.png":
        Module = require("private/Images/icon-giftcard.png");
        break;
      case "Images/icon-gift-card-black.png":
        Module = require("private/Images/icon-gift-card-black.png");
        break;
      case "Images/icon-debit-card.png":
        Module = require("private/Images/icon-debit-card.png");
        break;
      case "Images/icon-debit-card-active.png":
        Module = require("private/Images/icon-debit-card-active.png");
        break;
      case "Images/unchecked-checkbox.png":
        Module = require("private/Images/unchecked-checkbox.png");
        break;
      case "Images/checked-checkbox.png":
        Module = require("private/Images/checked-checkbox.png");
        break;
      case "Images/unchecked-checkbox-failure.png":
        Module = require("private/Images/unchecked-checkbox-failure.png");
        break;
      case "Images/badgeCheck.png":
        Module = require("private/Images/badgeCheck.png");
        break;
      case "Images/icon-loyalty.png":
        Module = require("private/Images/icon-loyalty.png");
        break;
      case "Images/AustenImage.png":
        Module = require("private/Images/AustenImage.png");
        break;
      case "Images/CelinaImage.png":
        Module = require("private/Images/CelinaImage.png");
        break;
      case "Images/JulieImage.png":
        Module = require("private/Images/JulieImage.png");
        break;
      case "Images/img-tkd-welcome-hero.jpg":
        Module = require("private/Images/img-tkd-welcome-hero.jpg");
        break;
      case "Images/img-tkd-welcomeHero-spanish.png":
        Module = require("private/Images/img-tkd-welcomeHero-spanish.png");
        break;
      case "Images/BioLife_Exclamation_Point_Icon.png": 
        Module = require("private/Images/BioLife_Exclamation_Point_Icon.png");
        break;
      case "Images/img-tkd-promo-hero.png":
        Module = require("private/Images/img-tkd-promo-hero.png");
        break;
      case "Images/img-tkd-biolife.jpg":
        Module = require("private/Images/img-tkd-biolife.jpg");
        break;
      case "Images/img-tkd-edu-sub-hero.jpg":
        Module = require("private/Images/img-tkd-edu-sub-hero.jpg");
        break;
      case "Images/img-tkd-refer-hero.jpg":
        Module = require("private/Images/img-tkd-refer-hero.jpg");
        break;
      case "Images/icon-tkd-logo.png":
        Module = require("private/Images/icon-tkd-logo.png");
        break;
      case "Images/icon-tkd-nav-menu.png":
        Module = require("private/Images/icon-tkd-nav-menu.png");
        break;
      case "Images/icon-tkd-appointments.png":
        Module = require("private/Images/icon-tkd-appointments.png");
        break;
      case "Images/icon-tkd-connect.png":
        Module = require("private/Images/icon-tkd-connect.png");
        break;
      case "Images/icon-tkd-education.png":
        Module = require("private/Images/icon-tkd-education.png");
        break;
      case "Images/icon-tkd-locations.png":
        Module = require("private/Images/icon-tkd-locations.png");
        break;
      case "Images/icon-tkd-notifications.png":
        Module = require("private/Images/icon-tkd-notifications.png");
        break;
      case "Images/icon-tkd-payment-hist.png":
        Module = require("private/Images/icon-tkd-payment-hist.png");
        break;
      case "Images/icon-tkd-profile.png":
        Module = require("private/Images/icon-tkd-profile.png");
        break;
      case "Images/icon-tkd-settings.png":
        Module = require("private/Images/icon-tkd-settings.png");
        break;
      case "Images/icon-tkd-nav-signout.png":
        Module = require("private/Images/icon-tkd-nav-signout.png");
        break;
      case "Images/icon-tkd-donate.png":
        Module = require("private/Images/icon-tkd-donate.png");
        break;
      case "Images/icon-tkd-home.png":
        Module = require("private/Images/icon-tkd-home.png");
        break;
      case "Images/icon-tkd-promo.png":
        Module = require("private/Images/icon-tkd-promo.png");
        break;
      case "Images/icon-tkd-refer.png":
        Module = require("private/Images/icon-tkd-refer.png");
        break;
      case "Images/icon-appointment-confirmed.png":
        Module = require("private/Images/icon-appointment-confirmed.png");
        break;
      case "Images/icon-tkd-confirm-appointment-type.png":
        Module = require("private/Images/icon-tkd-confirm-appointment-type.png");
        break;
      case "Images/icon-tkd-confirm-playroom.png":
        Module = require("private/Images/icon-tkd-confirm-playroom.png");
        break;
      case "Images/icon-tkd-grid.png":
        Module = require("private/Images/icon-tkd-grid.png");
        break;
      case "Images/icon-tkd-red-lock.png":
        Module = require("private/Images/icon-tkd-red-lock.png");
        break;
      case "Images/icon-tkd-amenities.png":
        Module = require("private/Images/icon-tkd-amenities.png");
        break;
      case "Images/icon-tkd-call-white.png":
        Module = require("private/Images/icon-tkd-call-white.png");
        break;
      case "Images/icon-tkd-hours.png":
        Module = require("private/Images/icon-tkd-hours.png");
        break;
      case "Images/icon-tkd-pin-mini-white.png":
        Module = require("private/Images/icon-tkd-pin-mini-white.png");
        break;
      case "Images/icon-tkd-promos.png":
        Module = require("private/Images/icon-tkd-promos.png");
        break;
      case "Images/icon-tkd-refer-donations.png":
        Module = require("private/Images/icon-tkd-refer-donations.png");
        break;
      case "Images/icon-tkd-refer-debit.png":
        Module = require("private/Images/icon-tkd-refer-debit.png");
        break;
      case "Images/icon-tkd-refer-share.png":
        Module = require("private/Images/icon-tkd-refer-share.png");
        break;
      case "Images/icon-tkd-info-green.png":
        Module = require("private/Images/icon-tkd-info-green.png");
        break;
      case "Images/icon-tkd-star-gray.png":
        Module = require("private/Images/icon-tkd-star-gray.png");
        break;
      case "Images/icon-tkd-star-light-green.png":
        Module = require("private/Images/icon-tkd-star-light-green.png");
        break;
      case "Images/icon-tkd-call.png":
        Module = require("private/Images/icon-tkd-call.png");
        break;
      case "Images/icon-tkd-pin-mini.png":
        Module = require("private/Images/icon-tkd-pin-mini.png");
        break;
      case "Images/icon-tkd-debit-card.png":
        Module = require("private/Images/icon-tkd-debit-card.png");
        break;
      case "Images/icon-youtube.png":
        Module = require("private/Images/icon-youtube.png");
        break;
      case "Images/icon-facebook.png":
        Module = require("private/Images/icon-facebook.png");
        break;
      case "Images/icon-pinterest.png":
        Module = require("private/Images/icon-pinterest.png");
        break;
      case "Images/icon-tkd-chevron-left.png":
        Module = require("private/Images/icon-tkd-chevron-left.png");
        break;
      case "Images/icon-tkd-chevron-right.png":
        Module = require("private/Images/icon-tkd-chevron-right.png");
        break;
      case "Images/faceIcon.png":
        Module = require("private/Images/faceIcon.png");
        break;
      case "Images/icon-globe.png":
        Module = require("private/Images/icon-globe.png");
        break;
      case "Images/icon-tkd-edu-who.png":
        Module = require("private/Images/icon-tkd-edu-who.png");
        break;
      case "Images/icon-tkd-edu-why.png":
        Module = require("private/Images/icon-tkd-edu-why.png");
        break;
      case "Images/icon-tkd-edu-first-donor.png":
        Module = require("private/Images/icon-tkd-edu-first-donor.png");
        break;
      case "Images/icon-tkd-edu-nutrition.png":
        Module = require("private/Images/icon-tkd-edu-nutrition.png");
        break;
      case "Images/icon-tkd-edu-eligible.png":
        Module = require("private/Images/icon-tkd-edu-eligible.png");
        break;
      case "Images/icon-tkd-edu-process.png":
        Module = require("private/Images/icon-tkd-edu-process.png");
        break;
      case "Images/icon-tkd-edu-plasma.png":
        Module = require("private/Images/icon-tkd-edu-plasma.png");
        break;
      case "Images/icon-tkd-edu-promos.png":
        Module = require("private/Images/icon-tkd-edu-promos.png");
        break;
      case "Images/icon-tkd-edu-faqs.png":
        Module = require("private/Images/icon-tkd-edu-faqs.png");
        break;
      case "Images/icon-tkd-edu-legal.png":
        Module = require("private/Images/icon-tkd-edu-legal.png");
        break;
      case "Images/icon-tkd-edu-contactus.png":
        Module = require("private/Images/icon-tkd-edu-contactus.png");
        break;
      case "Images/icon-tkd-edu-video.png":
        Module = require("private/Images/icon-tkd-edu-video.png");
        break;
      case "Images/icon-tkd-edu-mobile-faqs.png":
        Module = require("private/Images/icon-tkd-edu-mobile-faqs.png");
        break;
      case "Images/GrayInfoIcon.png":
        Module = require("private/Images/GrayInfoIcon.png");
        break;
      case "Images/pinkInfoIcon.png":
        Module = require("private/Images/pinkInfoIcon.png");
        break;
      case "Images/InstagramIcon.png":
        Module = require("private/Images/InstagramIcon.png");
        break;
      case "Images/LinkedInIcon.png":
        Module = require("private/Images/LinkedInIcon.png");
        break;
      case "Images/biolife-gift-card.png":
        Module = require("private/Images/biolife-gift-card.png");
        break;
      case "Images/biolife-debit-card.png":
        Module = require("private/Images/biolife-debit-card.png");
        break;
      case "Images/home-debit-card-balance-icon":
        Module = require("private/Images/home-debit-card-balance-icon");
        break;
      case "Images/home-my-biolife-rewards-icon-fpo":
        Module = require("private/Images/home-my-biolife-rewards-icon-fpo");
        break;
      case "Images/profile-lock":
        Module = require("private/Images/profile-lock");
        break;
      case "Theme/Images":
        Module = require("private/Theme/Images");
        break;
      case "Images/nav-home-icon":
        Module = require("private/Images/nav-home-icon");
        break;
      case "Images/nav-home-icon-selected":
        Module = require("private/Images/nav-home-icon-selected");
        break;
      case "Images/nav-promotion-icon":
        Module = require("private/Images/nav-promotion-icon");
        break;
      case "Images/nav-promotion-icon-selected":
        Module = require("private/Images/nav-promotion-icon-selected");
        break;
      case "Images/nav-donate-icon":
        Module = require("private/Images/nav-donate-icon");
        break;
      case "Images/nav-rewards-icon":
        Module = require("private/Images/nav-rewards-icon");
        break;
      case "Images/nav-rewards-icon-selected":
        Module = require("private/Images/nav-rewards-icon-selected");
        break;
      case "Images/nav-more-icon":
        Module = require("private/Images/nav-more-icon");
        break;
      case "Images/nav-more-icon-message":
        Module = require("private/Images/nav-more-icon-message");
        break;
      case "Images/avatar-example.png":
        Module = require("private/Images/avatar-example.png");
        break;
      case "Images/home-center-icon.png":
        Module = require("private/Images/home-center-icon.png");
        break;
      case "Images/close-icon.png":
        Module = require("private/Images/close-icon.png");
        break;
      case "Images/sign-up-icon-gradient-ui-success":
        Module = require("private/Images/sign-up-icon-gradient-ui-success");
        break;
      case "Images/bg-dots":
        Module = require("private/Images/bg-dots");
        break;
      case "Images/icon-circled-collapsed":
        Module = require("private/Images/icon-circled-collapsed");
        break;
      case "Images/icon-circled-expand":
        Module = require("private/Images/icon-circled-expand");
        break;
      case "Images/icon-calendar":
        Module = require("private/Images/icon-calendar");
        break;
      case "Images/phoneIcon":
        Module = require("private/Images/phoneIcon");
        break;
      case "Images/icon-clock":
        Module = require("private/Images/icon-clock");
        break;
      case "Images/circle-arrow-right":
        Module = require("private/Images/circle-arrow-right");
        break;
      case "Images/icon-home":
        Module = require("private/Images/icon-home");
        break;
      case "Images/address-location-icon":
        Module = require("private/Images/address-location-icon");
        break;
      case "Images/phone-icon":
        Module = require("private/Images/phone-icon");
        break;
      case "Images/time-icon":
        Module = require("private/Images/time-icon");
        break;
      case "Images/map-pin/map-pin.png":
        Module = require("private/Images/map-pin/map-pin.png");
        break;
      case "Images/icon-chevron-up":
        Module = require("private/Images/icon-chevron-up");
        break;
      case "Images/icon-quest-tracker-marker":
        Module = require("private/Images/icon-quest-tracker-marker");
        break;
      case "Images/icon-ndq-final-trophy":
        Module = require("private/Images/icon-ndq-final-trophy");
        break;
      case "Images/icon-ndq-mission-completed-medal":
        Module = require("private/Images/icon-ndq-mission-completed-medal");
        break;
      case "Images/icon-quest-complete-trophy":
        Module = require("private/Images/icon-quest-complete-trophy");
        break;
      case "Images/icon-apple":
        Module = require("private/Images/icon-apple");
        break;
      case "Images/icon-bottle":
        Module = require("private/Images/icon-bottle");
        break;
      case "Images/icon-cal-time":
        Module = require("private/Images/icon-cal-time");
        break;
      case "Images/icon-hand-money":
        Module = require("private/Images/icon-hand-money");
        break;
      case "Images/icon-handshake":
        Module = require("private/Images/icon-handshake");
        break;
      case "Images/icon-id-card":
        Module = require("private/Images/icon-id-card");
        break;
      case "Images/icon-med-exam":
        Module = require("private/Images/icon-med-exam");
        break;
      case "Images/icon-msg-search":
        Module = require("private/Images/icon-msg-search");
        break;
      case "Images/icon-music":
        Module = require("private/Images/icon-music");
        break;
      case "Images/icon-pressure-cuff":
        Module = require("private/Images/icon-pressure-cuff");
        break;
      case "Images/icon-saline":
        Module = require("private/Images/icon-saline");
        break;
      case "Images/icon-sleep":
        Module = require("private/Images/icon-sleep");
        break;
      case "Images/icon-ssn-card":
        Module = require("private/Images/icon-ssn-card");
        break;
      case "Images/icon-time":
        Module = require("private/Images/icon-time");
        break;
      case "Images/icon-two-hearts":
        Module = require("private/Images/icon-two-hearts");
        break;
      case "Theme/Colors":
        Module = require("private/Theme/Colors");
        break;
      case "Components/CenterWithImageCard":
        Module = require("private/Components/CenterWithImageCard");
        break;
      case "Components/Buttons/PrimaryButton":
        Module = require("private/Components/Buttons/PrimaryButton");
        break;
      case "Components/DynamicContent":
        Module = require("private/Components/DynamicContent");
        break;
      case "Components/Button":
        Module = require("private/Components/Button");
        break;
      case "Components/Separator":
        Module = require("private/Components/Separator");
        break;
      case "Components/TextComponent":
        Module = require("private/Components/TextComponent");
        break;
      case "Components/BiolifeRewards":
        Module = require("private/Components/BiolifeRewards");
        break;
      case "Containers/WaysToEarn":
        Module = require("private/Containers/WaysToEarn");
        break;
      case "Components/SuccessBanner":
        Module = require("private/Components/SuccessBanner");
        break;
      case "Containers/Rewards":
        Module = require("private/Containers/Rewards");
        break;
      case "Containers/RedeemRewardsSuccess":
        Module = require("private/Containers/RedeemRewardsSuccess");
        break;
      case "Components/BiolifeRewards/TopEarningActivity":
        Module = require("private/Components/BiolifeRewards/TopEarningActivity");
        break;
      case "Components/BiolifeRewards/MyAcheivements":
        Module = require("private/Components/BiolifeRewards/MyAcheivements");
        break;
      case "Components/ListComponent":
        Module = require("private/Components/ListComponent");
        break;
      case "Components/BiolifeRewards/RecentRewardActivity":
        Module = require("private/Components/BiolifeRewards/RecentRewardActivity");
        break;
      case "Containers/RewardsHistory":
        Module = require("private/Containers/RewardsHistory");
        break;
      case "Containers/MyAcheivementsPage":
        Module = require("private/Containers/MyAcheivementsPage");
        break;
      case "Components/Spacer":
        Module = require("private/Components/Spacer");
        break;
      case "Components/ImageComponent":
        Module = require("private/Components/ImageComponent");
        break;
      case "Components/Forms/LoginForm":
        Module = require("private/Components/Forms/LoginForm");
        break;
      case "Components/ToggleSwitch":
        Module = require("private/Components/ToggleSwitch");
        break;
      case "Components/Buttons/OutlineButton":
        Module = require("private/Components/Buttons/OutlineButton");
        break;
      case "Components/TextBanner":
        Module = require("private/Components/TextBanner");
        break;
      case "Components/NoCenterSelected":
        Module = require("private/Components/NoCenterSelected");
        break;
      case "Theme/Fonts":
        Module = require("private/Theme/Fonts");
        break;
      case "Containers/Welcome/styles":
        Module = require("private/Containers/Welcome/styles");
        break;
      case "Styles/Auth/styles":
        Module = require("private/Styles/Auth/styles");
        break;
      case "Components/AuthModal":
        Module = require("private/Components/AuthModal");
        break;
      case "Containers/ChangePaymentMethod":
        Module = require("private/Containers/ChangePaymentMethod");
        break;
      case "Containers/ChangePaymentMethod/styles":
        Module = require("private/Containers/ChangePaymentMethod/styles");
        break;
      case "Containers/ChangePaymentMethod/CheckboxCard/index":
        Module = require("private/Containers/ChangePaymentMethod/CheckboxCard/index");
        break;
      case "Containers/BiolifePaymentCardsModal/styles":
        Module = require("private/Containers/BiolifePaymentCardsModal/styles");
        break;
      case "Components/DashboardBanner":
        Module = require("private/Components/DashboardBanner");
        break;
      case "Components/DashboardStatistics":
        Module = require("private/Components/DashboardStatistics");
        break;
      case "Components/DebitStatistics":
        Module = require("private/Components/DebitStatistics");
        break;
      case "Components/PaymentActivity":
        Module = require("private/Components/PaymentActivity");
        break;
      case "Components/BiolifeRewards/PaymentHistoryList":
        Module = require("private/Components/BiolifeRewards/PaymentHistoryList");
        break;
      case "Components/BiolifeRewards/DebitHistoryList":
        Module = require("private/Components/BiolifeRewards/DebitHistoryList");
        break;
      case "Components/HorizontalSlider":
        Module = require("private/Components/HorizontalSlider");
        break;
      case "Components/GraphicTileComponent/GraphicTileTemplateOne":
        Module = require("private/Components/GraphicTileComponent/GraphicTileTemplateOne");
        break;
      case "Components/GraphicTileComponent/GraphicTileTemplateTwo":
        Module = require("private/Components/GraphicTileComponent/GraphicTileTemplateTwo");
        break;
      case "Components/GraphicTileComponent/GraphicTileTemplateThree":
        Module = require("private/Components/GraphicTileComponent/GraphicTileTemplateThree");
        break;
      case "Components/GraphicTileComponent/NDBPromotionsCard":
        Module = require("private/Components/GraphicTileComponent/NDBPromotionsCard");
        break;
      case "Components/CarouselComponent":
        Module = require("private/Components/CarouselComponent");
        break;
      case "Components/AppointmentCard":
        Module = require("private/Components/AppointmentCard");
        break;
      case "Components/SelectDropDown":
        Module = require("private/Components/SelectDropDown");
        break;
      case "Helpers/Utils":
        Module = require("private/Helpers/Utils");
        break;
      case "Helpers/changeLanguage":
        Module = require("private/Helpers/changeLanguage");
        break;
      case "Containers/Welcome":
        Module = require("private/Containers/Welcome");
        break;
      case "Components/Switch":
        Module = require("private/Components/Switch");
        break;
      case "Components/CheckboxLabel/styles":
        Module = require("private/Components/CheckboxLabel/styles");
        break;
      case "Components/CheckboxLabel":
        Module = require("private/Components/CheckboxLabel");
        break;
      case "Containers/Preferences/styles":
        Module = require("private/Containers/Preferences/styles");
        break;
      case "Containers/Preferences/Components/Modal":
        Module = require("private/Containers/Preferences/Components/Modal");
        break;
      case "Containers/Education/getContent":
        Module = require("private/Containers/Education/getContent");
        break;
      case "Services/Linking":
        Module = require("private/Services/Linking");
        break;
      case "Components/WebViewComponent":
        Module = require("private/Components/WebViewComponent");
        break;
      case "Components/CheckBoxContainer":
        Module = require("private/Components/CheckBoxContainer");
        break;
      case "Containers/Preferences":
        Module = require("private/Containers/Preferences");
        break;
      case "Containers/AccountSetting/styles.js":
        Module = require("private/Containers/AccountSetting/styles.js");
        break;
      case "Components/AuthInputText/styles":
        Module = require("private/Components/AuthInputText/styles");
        break;
      case "Components/AuthInputText":
        Module = require("private/Components/AuthInputText");
        break;
      case "Containers/AccountSetting/styles":
        Module = require("private/Containers/AccountSetting/styles");
        break;
      case "Containers/AccountSetting":
        Module = require("private/Containers/AccountSetting");
        break;
      case "Components/AuthHeader/styles":
        Module = require("private/Components/AuthHeader/styles");
        break;
      case "Components/AuthHeader":
        Module = require("private/Components/AuthHeader");
        break;
      case "Components/StageHeader/Register":
        Module = require("private/Components/StageHeader/Register");
        break;
      case "Components/Register/styles":
        Module = require("private/Components/Register/styles");
        break;
      case "Containers/SignUp":
        Module = require("private/Containers/SignUp");
        break;
      case "Styles/Register/CreateProfile":
        Module = require("private/Styles/Register/CreateProfile");
        break;
      case "Components/TwoColumn":
        Module = require("private/Components/TwoColumn");
        break;
      case "Components/Items/Register/DonationCenter":
        Module = require("private/Components/Items/Register/DonationCenter");
        break;
      case "Containers/CreateProfile":
        Module = require("private/Containers/CreateProfile");
        break;
      case "Containers/EmailConfirmation":
        Module = require("private/Containers/EmailConfirmation");
        break;
      case "Containers/AuthForgotPassword/styles":
        Module = require("private/Containers/AuthForgotPassword/styles");
        break;
      case "Containers/AuthForgotPassword":
        Module = require("private/Containers/AuthForgotPassword");
        break;
      case "Containers/AuthForgotPasswordSuccess":
        Module = require("private/Containers/AuthForgotPasswordSuccess");
        break;
      case "Components/BiometricsAuthInputText/styles":
        Module = require("private/Components/BiometricsAuthInputText/styles");
        break;
      case "Components/BiometricsAuthInputText":
        Module = require("private/Components/BiometricsAuthInputText");
        break;
      case "Containers/SignIn":
        Module = require("private/Containers/SignIn");
        break;
      case "Containers/SignInAuth":
        Module = require("private/Containers/SignInAuth");
        break;
      case "Containers/SignOut":
        Module = require("private/Containers/SignOut");
        break;
      case "Theme/globalStyles":
        Module = require("private/Theme/globalStyles");
        break;
      case "Containers/AuthSignUp/styles":
        Module = require("private/Containers/AuthSignUp/styles");
        break;
      case "Containers/AuthSignUp":
        Module = require("private/Containers/AuthSignUp");
        break;
      case "Components/Modal/styles":
        Module = require("private/Components/Modal/styles");
        break;
      case "Components/Modal":
        Module = require("private/Components/Modal");
        break;
      case "Components/Inputs/CustomCheckbox":
        Module = require("private/Components/Inputs/CustomCheckbox");
        break;
      case "Components/CustomModal":
        Module = require("private/Components/CustomModal");
        break;
      case "Components/CustomModal/LoyaltyEnrolmentModal":
        Module = require("private/Components/CustomModal/LoyaltyEnrolmentModal");
        break;
      case "Components/CustomModal/LoyaltyEnrolmentSuccessModal":
        Module = require("private/Components/CustomModal/LoyaltyEnrolmentSuccessModal");
        break;
      case "Components/CustomModal/TextCTAModal":
        Module = require("private/Components/CustomModal/TextCTAModal");
        break;
      case "Containers/Registration":
        Module = require("private/Containers/Registration");
        break;
      case "Containers/NoCenters":
        Module = require("private/Containers/NoCenters");
        break;
      case "Containers/AccountSetupSuccess":
        Module = require("private/Containers/AccountSetupSuccess");
        break;
      case "Components/SessionTracker":
        Module = require("private/Components/SessionTracker");
        break;
      case "Containers/Dashboard/styles":
        Module = require("private/Containers/Dashboard/styles");
        break;
      case "Containers/Dashboard":
        Module = require("private/Containers/Dashboard");
        break;
      case "Containers/Profile/Components/FormInput/select":
        Module = require("private/Containers/Profile/Components/FormInput/select");
        break;
      case "Containers/Profile/Components/ViewInfo":
        Module = require("private/Containers/Profile/Components/ViewInfo");
        break;
      case "Containers/Profile/Components/FormInput/text":
        Module = require("private/Containers/Profile/Components/FormInput/text");
        break;
      case "Containers/Profile/Components/EditInfo":
        Module = require("private/Containers/Profile/Components/EditInfo");
        break;
      case "Containers/Profile/styles":
        Module = require("private/Containers/Profile/styles");
        break;
      case "Components/ContentsTab/styles":
        Module = require("private/Components/ContentsTab/styles");
        break;
      case "Components/ContentsTab":
        Module = require("private/Components/ContentsTab");
        break;
      case "Containers/Profile":
        Module = require("private/Containers/Profile");
        break;
      case "Containers/AppointmentDetails/styles":
        Module = require("private/Containers/AppointmentDetails/styles");
        break;
      case "Containers/AppointmentDetails":
        Module = require("private/Containers/AppointmentDetails");
        break;
      case "Containers/AppointmentReschedule":
        Module = require("private/Containers/AppointmentReschedule");
        break;
      case "Containers/MyAppointments":
        Module = require("private/Containers/MyAppointments");
        break;
      case "Containers/ChangePaymentMethod":
        Module = require("private/Containers/ChangePaymentMethod");
        break;
      case "Helpers/AddToCalendar":
        Module = require("private/Helpers/AddToCalendar");
        break;
      case "Containers/AppointmentSchedule":
        Module = require("private/Containers/AppointmentSchedule");
        break;
      case "Components/AlternateDonationCenterCard":
        Module = require("private/Components/AlternateDonationCenterCard");
        break;
      case "Containers/AppointmentConfirmed":
        Module = require("private/Containers/AppointmentConfirmed");
        break;
      case "Containers/AppointmentActivity/styles":
        Module = require("private/Containers/AppointmentActivity/styles");
        break;
      case "Containers/AppointmentActivity":
        Module = require("private/Containers/AppointmentActivity");
        break;
      case "Components/Accordion/styles":
        Module = require("private/Components/Accordion/styles");
        break;
      case "Components/Accordion":
        Module = require("private/Components/Accordion");
        break;
      case "Containers/Donation/styles":
        Module = require("private/Containers/Donation/styles");
        break;
      case "Components/ScheduleComponents/Activity":
        Module = require("private/Components/ScheduleComponents/Activity");
        break;
      case "Components/ScheduleComponents/DateSelector":
        Module = require("private/Components/ScheduleComponents/DateSelector");
        break;
      case "Components/ScheduleComponents/TimeSelector":
        Module = require("private/Components/ScheduleComponents/TimeSelector");
        break;
      case "Components/ScheduleComponents/TimeSlotSelector":
        Module = require("private/Components/ScheduleComponents/TimeSlotSelector");
        break;
      case "Components/ScheduleComponents/LocationSelector":
        Module = require("private/Components/ScheduleComponents/LocationSelector");
        break;
      case "Components/Select/styles":
        Module = require("private/Components/Select/styles");
        break;
      case "Components/Select":
        Module = require("private/Components/Select");
        break;
      case "Components/AppointmentTypeDropdown":
        Module = require("private/Components/AppointmentTypeDropdown");
        break;
      case "Components/SuccessAccordion":
        Module = require("private/Components/SuccessAccordion");
        break;
      case "Components/ScheduleComponents/Perferences":
        Module = require("private/Components/ScheduleComponents/Perferences");
        break;
      case "Components/AppointmentStatistics":
        Module = require("private/Components/AppointmentStatistics");
        break;
      case "Components/AppointmentDetails":
        Module = require("private/Components/AppointmentDetails");
        break;
      case "Components/UpcomingAppointments":
        Module = require("private/Components/UpcomingAppointments");
        break;
      case "Components/DonorSpecificText":
        Module = require("private/Components/DonorSpecificText");
        break;
      case "Containers/AppointmentReschedule":
        Module = require("private/Containers/AppointmentReschedule");
        break;
      case "Containers/ConfirmAppointment/styles":
        Module = require("private/Containers/ConfirmAppointment/styles");
        break;
      case "Containers/ConfirmAppointment":
        Module = require("private/Containers/ConfirmAppointment");
        break;
      case "Components/ScheduleComponents/Confirm":
        Module = require("private/Components/ScheduleComponents/Confirm");
        break;
      case "Containers/ConfirmReschedule":
        Module = require("private/Containers/ConfirmReschedule");
        break;
      case "Components/ScheduleComponents/Success":
        Module = require("private/Components/ScheduleComponents/Success");
        break;
      case "Containers/RescheduleSuccess":
        Module = require("private/Containers/RescheduleSuccess");
        break;
      case "Containers/CancelAppointment/styles":
        Module = require("private/Containers/CancelAppointment/styles");
        break;
      case "Containers/CancelAppointment":
        Module = require("private/Containers/CancelAppointment");
        break;
      case "Containers/CancelAppointmentConfirm/styles":
        Module = require("private/Containers/CancelAppointmentConfirm/styles");
        break;
      case "Containers/CancelAppointmentConfirm":
        Module = require("private/Containers/CancelAppointmentConfirm");
        break;
      case "Containers/Notification/styles":
        Module = require("private/Containers/Notification/styles");
        break;
      case "Containers/Notification":
        Module = require("private/Containers/Notification");
        break;
      case "Containers/Notification/Components/NotificationDetails":
        Module = require("private/Containers/Notification/Components/NotificationDetails");
        break;
      case "Containers/TermsOfUse":
        Module = require("private/Containers/TermsOfUse");
        break;
      case "Containers/NonDiscriminationStatement":
        Module = require("private/Containers/NonDiscriminationStatement");
        break;
      case "Containers/PrivacyNotice":
        Module = require("private/Containers/PrivacyNotice");
        break;
      case "Containers/ContactUsPublic":
        Module = require("private/Containers/ContactUsPublic");
        break;
      case "Containers/AccessibilityStatement":
        Module = require("private/Containers/AccessibilityStatement");
        break;
      case "Containers/Referral/styles":
        Module = require("private/Containers/Referral/styles");
        break;
      case "Containers/Referral":
        Module = require("private/Containers/Referral");
        break;
      case "Containers/Promotions/styles":
        Module = require("private/Containers/Promotions/styles");
        break;
      case "Containers/Promotions":
        Module = require("private/Containers/Promotions");
        break;
      case "Containers/Donation":
        Module = require("private/Containers/Donation");
        break;
      case "Containers/Locations/Components/LocationInformation":
        Module = require("private/Containers/Locations/Components/LocationInformation");
        break;
      case "Containers/Locations/styles":
        Module = require("private/Containers/Locations/styles");
        break;
      case "Containers/Locations/Components/LocationListItem":
        Module = require("private/Containers/Locations/Components/LocationListItem");
        break;
      case "Containers/MyCenter/styles":
        Module = require("private/Containers/MyCenter/styles");
        break;
      case "Containers/MyCenter":
        Module = require("private/Containers/MyCenter");
        break;
      case "Containers/PaymentHistory/styles":
        Module = require("private/Containers/PaymentHistory/styles");
        break;
      case "Containers/PaymentHistory":
        Module = require("private/Containers/PaymentHistory");
        break;
      case "Containers/DebitHistory/styles":
        Module = require("private/Containers/DebitHistory/styles");
        break;
      case "Containers/DebitHistory":
        Module = require("private/Containers/DebitHistory");
        break;
      case "Containers/ConnectUs/styles":
        Module = require("private/Containers/ConnectUs/styles");
        break;
      case "Containers/ConnectUs":
        Module = require("private/Containers/ConnectUs");
        break;
      case "Containers/Locations":
        Module = require("private/Containers/Locations");
        break;
      case "Containers/Education/styles":
        Module = require("private/Containers/Education/styles");
        break;
      case "Containers/Education/getMenu":
        Module = require("private/Containers/Education/getMenu");
        break;
      case "Containers/Education":
        Module = require("private/Containers/Education");
        break;
      case "Containers/Education/Components/Subpage/styles":
        Module = require("private/Containers/Education/Components/Subpage/styles");
        break;
      case "Containers/Education/Components/Subpage":
        Module = require("private/Containers/Education/Components/Subpage");
        break;
      case "Containers/Education/Components/Legal":
        Module = require("private/Containers/Education/Components/Legal");
        break;
      case "Containers/ProxyLogin/styles":
        Module = require("private/Containers/ProxyLogin/styles");
        break;
      case "Containers/ProxyLogin":
        Module = require("private/Containers/ProxyLogin");
        break;
      case "Navigators/AppNavigatorConfig":
        Module = require("private/Navigators/AppNavigatorConfig");
        break;
      case "Navigators/BottomNavigator":
        Module = require("private/Navigators/BottomNavigator");
        break;
      case "Navigators/DrawerItem":
        Module = require("private/Navigators/DrawerItem");
        break;
      case "Navigators/drawerStyles":
        Module = require("private/Navigators/drawerStyles");
        break;
      case "Components/LanguageToggler/styles":
        Module = require("private/Components/LanguageToggler/styles");
        break;
      case "Components/LanguageToggler":
        Module = require("private/Components/LanguageToggler");
        break;
      case "Components/MenuHeader":
        Module = require("private/Components/MenuHeader");
        break;
      case "Components/MenuHeader/styles":
        Module = require("private/Components/MenuHeader/styles");
        break;
      case "Containers/Promotions":
        Module = require("private/Containers/Promotions");
        break;
      case "Containers/Donate":
        Module = require("private/Containers/Donate");
        break;
      case "Containers/Rewards":
        Module = require("private/Containers/Rewards");
        break;
      case "Containers/AppHeader/helpers":
        Module = require("private/Containers/AppHeader/helpers");
        break;
      case "Theme":
        Module = require("private/Theme");
        break;
      case "Components/AppHeader/LeftComponent":
        Module = require("private/Components/AppHeader/LeftComponent");
        break;
      case "Components/AppHeader/RightComponent":
        Module = require("private/Components/AppHeader/RightComponent");
        break;
      case "Containers/AppHeader/styles":
        Module = require("private/Containers/AppHeader/styles");
        break;
      case "Containers/AppHeader":
        Module = require("private/Containers/AppHeader");
        break;
      case "Containers/AppAuthLoading":
        Module = require("private/Containers/AppAuthLoading");
        break;
      case "Navigators/DrawerNavigator":
        Module = require("private/Navigators/DrawerNavigator");
        break;
      case "Containers/AppointmentHistory":
        Module = require("private/Containers/AppointmentHistory");
        break;
      case "Components/AppointmentHistory":
        Module = require("private/Components/AppointmentHistory");
        break;
      case "Components/AppointmentHistory/styles":
        Module = require("private/Components/AppointmentHistory/styles");
        break;
      case "Components/Filter":
        Module = require("private/Components/Filter");
        break;
      case "Components/SpeCard":
        Module = require("private/Components/SpeCard");
        break;
      case "Components/SpeCardGeneric":
        Module = require("private/Components/SpeCardGeneric");
        break;
      case "Components/NonSPEDefferalCard":
        Module = require("private/Components/NonSPEDefferalCard");
        break;
      case "Containers/FilterPage":
        Module = require("private/Containers/FilterPage");
        break;
      case "Containers/ChooseFactor":
        Module = require("private/Containers/ChooseFactor");
        break;
      case "Containers/VerifyFactor":
        Module = require("private/Containers/VerifyFactor");
        break;
      case "Utils/commonHelpers":
        Module = require("common/Utils/commonHelpers");
        break;
      case "Images/search-icon":
        Module = require("private/Images/search-icon");
        break;
      case "Images/address-location-icon":
        Module = require("private/Images/address-location-icon");
        break;
      case "Images/phoneIcon":
        Module = require("private/Images/phoneIcon");
        break;
      case "Images/information-icon":
        Module = require("private/Images/information-icon");
        break;
      case "Images/sign-up-icon-gradient-ui-success":
        Module = require("private/Images/sign-up-icon-gradient-ui-success");
        break;
      case "Images/blue_drop_icon":
        Module = require("private/Images/blue_drop_icon");
        break;
      case "Images/closeIcon":
        Module = require("private/Images/closeIcon");
        break;
      case "Images/UI-appointment-icon-16px1":
        Module = require("private/Images/UI-appointment-icon-16px1");
        break;
      case "Images/UI-filter-icon":
        Module = require("private/Images/UI-filter-icon");
        break;
      case "Sagas/Users/enrollMfa/main":
        Module = require("common/Sagas/Users/enrollMfa/main");
        break;
      case "Sagas/Users/enrollMfa/success":
        Module = require("common/Sagas/Users/enrollMfa/success");
        break;
      case "Sagas/Users/enrollMfa/failure":
        Module = require("common/Sagas/Users/enrollMfa/failure");
        break;
      case "Sagas/Users/resendEnrollMfaCode/main":
        Module = require("common/Sagas/Users/resendEnrollMfaCode/main");
        break;
      case "Sagas/Users/resendEnrollMfaCode/success":
        Module = require("common/Sagas/Users/resendEnrollMfaCode/success");
        break;
      case "Sagas/Users/resendEnrollMfaCode/failure":
        Module = require("common/Sagas/Users/resendEnrollMfaCode/failure");
        break;
      case "Sagas/Users/sendMfaCode/main":
        Module = require("common/Sagas/Users/sendMfaCode/main");
        break;
      case "Sagas/Users/sendMfaCode/success":
        Module = require("common/Sagas/Users/sendMfaCode/success");
        break;
      case "Sagas/Users/sendMfaCode/failure":
        Module = require("common/Sagas/Users/sendMfaCode/failure");
        break;
      case "Sagas/Users/authenticateMfaCode/main":
        Module = require("common/Sagas/Users/authenticateMfaCode/main");
        break;
      case "Sagas/Users/authenticateMfaCode/success":
        Module = require("common/Sagas/Users/authenticateMfaCode/success");
        break;
      case "Sagas/Users/authenticateMfaCode/failure":
        Module = require("common/Sagas/Users/authenticateMfaCode/failure");
        break;
      case "Sagas/Users/verifyMfaCode/main":
        Module = require("common/Sagas/Users/verifyMfaCode/main");
        break;
      case "Sagas/Users/verifyMfaCode/success":
        Module = require("common/Sagas/Users/verifyMfaCode/success");
        break;
      case "Sagas/Users/verifyMfaCode/failure":
        Module = require("common/Sagas/Users/verifyMfaCode/failure");
        break;
      case "Sagas/Users/getEnrolledMfaList/main":
        Module = require("common/Sagas/Users/getEnrolledMfaList/main");
        break;
      case "Sagas/Users/getEnrolledMfaList/success":
        Module = require("common/Sagas/Users/getEnrolledMfaList/success");
        break;
      case "Sagas/Users/getEnrolledMfaList/failure":
        Module = require("common/Sagas/Users/getEnrolledMfaList/failure");
        break;
      case "Sagas/Users/sendMfaCode/main":
        Module = require("common/Sagas/Users/sendMfaCode/main");
        break;
      case "Sagas/Users/sendMfaCode/success":
        Module = require("common/Sagas/Users/sendMfaCode/success");
        break;
      case "Sagas/Users/sendMfaCode/failure":
        Module = require("common/Sagas/Users/sendMfaCode/failure");
        break;
      case "APIs/loyalty":
        Module = require("common/APIs/loyalty");
        break;
      case "APIs/auth/deloit/enrollMfa":
        Module = require("common/APIs/auth/deloit/enrollMfa"); 
        break;
      case "APIs/auth/deloit/verifyMfaCode":
        Module = require("common/APIs/auth/deloit/verifyMfaCode");
        break;
      case "APIs/auth/deloit/getEnrolledMfaList":
        Module = require("common/APIs/auth/deloit/getEnrolledMfaList");
        break;
      case "APIs/auth/deloit/sendMfaCode":
        Module = require("common/APIs/auth/deloit/sendMfaCode");
        break;
      case "APIs/auth/deloit/authenticateMfaCode":
        Module = require("common/APIs/auth/deloit/authenticateMfaCode");
        break;
      case "Images/icon-chevron-down":
        Module = require("private/Images/icon-chevron-down");
        break;
      case "Images/appointment-type":
        Module = require("private/Images/appointment-type");
        break;
      default:
        console.log("module not founnd", name);
    } }
  return namedImport === null ? Module : Module[namedImport];
};
